export default {
  // --- App / global ---
  app_name: 'SwapWish TCG',
  ok: 'OK',
  cancel: 'Cancel',
  save: 'Save',
  apply: 'Apply',
  back: 'Back',
  loading: 'Loading',
  error_generic: 'An error occurred',
  retry: 'Retry',
  common_close: 'Close',
  common_loading: 'Loading',
  common_back: 'Back',
  common_search: 'Search',
  common_undo: 'Undo',
  common_clear_search: 'Clear search',
  common_clear_selection: 'Clear selection',
  load_more: 'Load more',
  collection_load_error: 'Could not load your collection. Check your connection and try again.',
  // Domain errors raised by RPCs (see utils/dbErrorMessages.ts).
  err_tourn_max_active: 'You can have at most 5 active tournaments at the same time.',
  err_tourn_not_verified: 'Only verified users can create tournaments.',
  err_tourn_past_date: 'The tournament date cannot be in the past.',
  err_tourn_own: 'You cannot join your own tournament.',
  err_tourn_full: 'Maximum number of participants reached.',
  err_tourn_unavailable: 'The tournament is no longer available.',
  err_tourn_winner_invalid: 'The winner must be an accepted participant of the tournament.',
  err_verify_pending: 'You already have a pending verification request.',
  err_verify_already: 'Your profile is already verified.',
  err_banner_not_verified: 'Only verified users can book banners.',
  err_banner_existing: 'You already have a banner in progress for this city.',
  err_banner_slot_occupied: 'Banner slot taken: you can complete the purchase when the active banner expires.',
  err_banner_queue_full: 'There is already an approved banner awaiting payment for this city.',
  err_trade_overcommit: 'Some quantities are no longer available: refresh your selection and try again.',
  err_trade_item_locked: 'One of the items is committed in another pending trade.',
  common_decrease_quantity: 'Decrease quantity',
  common_increase_quantity: 'Increase quantity',
  field_multi_selected_count: '{count} selected',
  card_tile_view_prices_aria: 'View prices for {name}',
  card_tile_edit_aria: 'Edit {name}',
  card_tile_save_aria: 'Save changes to {name}',
  card_tile_cancel_aria: 'Cancel changes to {name}',
  card_tile_quantity_badge: 'Quantity:',
  card_variant_holo: 'Holo',
  card_variant_reverse: 'Reverse',

  // --- Auth ---
  auth_sign_in: 'Sign In',
  auth_sign_up: 'Sign Up',
  auth_email: 'Email',
  auth_password: 'Password',
  auth_username: 'Username',
  auth_username_min: 'Username must be at least 6 characters',
  auth_username_max: 'Username must be at most 20 characters',
  auth_username_charset: 'Username can contain only letters and numbers',
  auth_submit_login: 'Sign In',
  auth_submit_register: 'Sign Up',
  auth_tagline: 'Find cards or sealed products, trade with people nearby.',
  auth_confirm_email: 'Account created. Check your email for confirmation, then sign in. If you don\'t find the email, check the spam folder.',
  auth_email_in_use: 'This email is already registered. Try signing in, including with Google if you used it before.',
  auth_error: 'Authentication error',
  auth_invalid_credentials: 'Invalid credentials',
  auth_show_password: 'Show password',
  auth_hide_password: 'Hide password',
  auth_password_min: 'Password must be at least 6 characters.',
  auth_password_hint: 'At least 8 characters, with uppercase and lowercase letters.',
  auth_forgot_password: 'Forgot password?',
  auth_forgot_title: 'Reset your password',
  auth_forgot_subtitle: 'Enter your account email: we\'ll send you a link to reset your password.',
  auth_forgot_send: 'Send reset link',
  auth_reset_need_email: 'Enter a valid email to reset the password.',
  auth_reset_sent: 'We sent you an email to reset your password. Check the spam folder too.',
  auth_reset_title: 'Reset password',
  auth_reset_subtitle: 'Choose a new password for your account.',
  auth_reset_new_password: 'New password',
  auth_reset_confirm_password: 'Repeat new password',
  auth_reset_submit: 'Proceed',
  auth_reset_mismatch: 'Passwords do not match.',
  auth_reset_expired: 'Recovery link invalid or expired. Request the reset again.',
  auth_reset_back_login: 'Back to login',
  auth_or_continue_with: 'or continue with',
  auth_google: 'Google',
  auth_first_name: 'First name',
  auth_last_name: 'Last name',
  auth_first_name_required: 'First name is required',
  auth_last_name_required: 'Last name is required',
  auth_disallowed_words_field: 'The field "{field}" contains words that are not allowed',
  auth_address: 'Address',
  auth_address_placeholder: 'Search by street, city, postcode',
  auth_address_hint: 'Used only to calculate approximate distances.',
  address_search_label: 'Address',
  address_search_placeholder: 'Search by street and number, city…',
  address_search_no_results: 'Address not found: enter a street (and number), not just the city',
  auth_callback_loading: 'Signing you in…',
  auth_callback_redirect_login: 'Redirecting to login…',
  auth_signup_confirmed_title: 'Registration complete!',
  auth_signup_confirmed_desc: 'Your email has been confirmed. You can close this page and go back to the SwapWish TCG app to sign in.',

  // --- Tabs ---
  tab_discover: 'Discover',
  tab_inventory: 'Binder',
  tab_wishlist: 'Wishlist',
  tab_matches: 'Matches',
  tab_profile: 'Profile',

  // --- Swipe ---
  swipe_set_location_title: 'Set your location',
  swipe_set_location_desc: 'We only show approximate distances. Your exact location is never stored.',
  swipe_enable_geo: 'Enable geolocation',
  swipe_searching: 'Looking for nearby matches',
  map_searching: 'Loading matches on the map',
  map_you: 'You',
  map_trade_button: 'Send proposal',
  map_candidates_title: 'Nearby trades',
  leaderboard_title: 'Trade leaderboard',
  leaderboard_short: 'Leaderboard',
  leaderboard_radius_subtitle: 'Best users found within {radius} km',
  leaderboard_empty: 'No users nearby.',
  leaderboard_no_rating: 'No reviews',
  leaderboard_trades: '{count} trades',
  public_profile_title: 'User profile',
  public_profile_view: 'View profile',
  last_seen_less_hour: 'Last seen: less than an hour ago',
  last_seen_one_hour: 'Last seen: 1 hour ago',
  last_seen_hours: 'Last seen: {count} hours ago',
  last_seen_one_day: 'Last seen: 1 day ago',
  last_seen_days: 'Last seen: {count} days ago',
  last_seen_weeks: 'Last seen: weeks ago',
  leaderboard_view_history: 'Trade history',
  leaderboard_view_reviews: 'View reviews',
  leaderboard_inventory: 'Inventory',
  leaderboard_three_way_badge: 'Three-way trade',
  history_completed_at: 'Completed on {date}',
  leaderboard_history_of: "{user}'s history",
  leaderboard_history_empty: 'No completed trades.',
  leaderboard_trade_of: '{a} ⇄ {b}',
  import_title: 'Bulk inventory import',
  import_settings_desc: 'Import your collection from external sources.',
  import_desc: 'Upload the export file (CSV or Excel) from the chosen platform: matched cards are added to your inventory. Unrecognized rows are skipped.',
  import_source: 'Source',
  import_hint_tcgplayer: 'TCGplayer coverage is limited: unmatched cards are skipped.',
  import_choose_file: 'Choose file (CSV/Excel)',
  import_start: 'Import',
  import_running: 'Importing…',
  import_error_empty: 'No valid rows found in the file.',
  import_stat_imported: 'Imported',
  import_stat_not_found: 'Not found',
  import_stat_errors: 'Errors',
  map_candidates_eyebrow: 'Users in range',
  map_candidates_tab_direct: 'Direct trades',
  map_candidates_tab_three_way: 'Three-way trades',
  map_candidates_cards: 'cards',
  map_candidates_products: 'products',
  map_candidates_cards_mine: 'your cards',
  map_candidates_products_mine: 'your products',
  map_candidates_cards_theirs: 'their cards',
  map_candidates_products_theirs: 'their products',
  map_candidates_trades: 'trades',
  map_candidate_new_badge: 'New',
  // Candidates list filter (direct trades only)
  map_filter_all: 'All',
  map_filter_compatible: 'Compatible',
  map_candidate_badge_compatible: 'Compatible',
  map_candidate_badge_nearby: 'Nearby',
  map_candidate_hint_compatible: 'Has cards from your wishlist',
  map_candidate_hint_nearby: 'Browse their collection and propose',
  // Intermediate card picker (candidate without matches)
  candidate_picker_title: 'Pick the products',
  candidate_picker_subtitle: "From {name}'s collection",
  candidate_picker_empty: 'No tradeable products available',
  candidate_picker_games_label: 'Games',
  candidate_picker_game_filter_aria: 'Filter results by {game}',
  candidate_picker_unknown_game: 'Other game',
  candidate_picker_cards_empty: 'No cards for the selected games.',
  candidate_picker_sealed_empty: 'No sealed products for the selected games.',
  map_three_way_cash_badge: 'Cash deal',
  map_details_btn: 'Details',
  map_candidate_details_aria: 'Details for {name}',
  map_candidates_details_hint: 'Tap a match with a user to view its details, swipe left to remove from the map.',
  map_three_way_bridge_details_aria: 'Three-way trade details',
  map_trade_failed: 'Could not start the trade. Please try again.',
  map_trade_three_way_active: 'There is already an active three-way trade with this user: complete or cancel it before starting a direct trade.',
  map_candidate_dismissed: 'Match removed: it will reappear only with new compatible cards.',
  map_pro_expired_banner: 'Your Pro subscription has expired: three-way trades are no longer loaded.',
  map_pro_expired_cta: 'Renew',
  map_pro_expired_later: 'Later',
  trade_flow_aria: 'Proposal progress',
  trade_flow_step_create: 'Send proposal',

  trade_flow_step_quantities: 'Quantities & amount',
  trade_flow_step_send: 'Send trade',
  map_three_way_count: '{count} three-way trades',
  map_three_way_a_to_b: 'You give to {user}',
  map_three_way_b_to_a: '{user} gives to you',
  map_three_way_c_to_b: '{from} gives to {to}',
  map_three_way_b_to_c: '{from} gives to {to}',
  swipe_resolving_location: 'Updating your location…',
  swipe_empty_title: 'No matches in range',
  map_candidates_empty_wishlist: 'No matches nearby. Add cards or sealed products to your wishlist to increase your chances of finding matches',
  swipe_empty_desc: 'There are no compatible profiles within your current range. Try expanding it through Filters button or check back later.',
  swipe_edit_radius: 'Edit range',
  products_filters_button: 'Filters',
  products_filters_title: 'Product filters',
  products_filters_any: 'Any',
  products_filters_three_way_title: 'Three-way trades',
  products_filters_three_way_hint: 'Also search circular three-way trades (A → B → C → A) on the map.',
  products_filters_requested_only_hint: 'Card and sealed filters are applied separately to products requested by candidates.',
  products_filters_tcg_multi_help: 'Select one TCG to search only within that game; selecting more than one (or none = all) enables combined matchmaking across multiple TCGs.',
  products_filters_tcg_single_help: 'With Pro you can select multiple TCGs at once and enable combined matchmaking.',
  products_filters_upgrade_pro: 'Activate Pro subscription',
  products_filters_cards_section: 'Cards',
  products_filters_sealed_section: 'Sealed',
  products_filters_condition: 'Card condition',
  products_filters_language: 'Language',
  products_filters_grading_company: 'Grading company',
  products_filters_grade: 'Grade',
  products_filters_sealed_category: 'Product type',
  products_filters_sealed_name: 'Search by name',
  products_filters_sealed_name_placeholder: 'E.g. Scarlet & Violet Booster Box…',
  swipe_outgoing_match_pending_warning: 'You have active matches. Users you have an active match with are not shown on the map again until the trade completes or is deleted. After deletion, the same pairing only returns when one of you has new compatible items.',
  swipe_free_active_match_cap_warning: 'Maximum of 4 active matches reached (unlock pro subscription for unlimited matches)',
  swipe_skip: 'Skip',
  swipe_like: 'Like',
  swipe_location_block_title: 'Location unavailable',
  swipe_location_block_desc: 'Geolocation is disabled or no address has been provided.',
  swipe_go_to_settings: 'Go to Settings',
  swipe_slot_block_title: 'Slot limit exceeded',
  swipe_slot_block_desc: 'Slot limit exceeded, activate the Pro subscription or reduce quantities in inventory and wishlist.',
  offline_title: 'Connection unavailable',
  offline_no_connection: 'Internet connection unavailable. It is impossible to access platform features.',
  mobile_no_internet: 'Internet connection unavailable',
  mobile_location_unavailable_no_address: 'Geolocation is not active and no default address is set in profile settings',
  mobile_location_using_profile_address: 'Geolocation is off: using the default address set in your profile',
  mobile_health_refresh_aria: 'Run check again',
  mobile_health_dismiss_aria: 'Dismiss notice',

  // --- Match popup ---
  match_cards_count: '{count} items in common',
  match_tap_to_view: 'Tap a card for details',

  // --- Inventory ---
  inv_title: 'My Binder',
  view_title_inventory: 'Collection',
  view_title_wishlist: 'Wishlist',
  view_title_catalog: 'Catalog',
  view_title_matches: 'Matches',
  view_title_history: 'History',
  view_title_notifications: 'Notifications',
  inv_slots: '{used}/{total} slots used',
  inv_slots_unlimited: '{used} slots used',
  inv_slot_limit_label: 'Inventory and wishlist limit for',
  inv_free_badge: 'free',
  slot_limit_reached_flash: 'Maximum number of available slots reached',
  inv_go_pro: 'Go Pro',
  inv_empty_title: 'Your binder is empty',
  inv_empty_desc: 'Tap the "Add to inventory" button to add your cards/sealed products to offer in trades.',
  inv_add: 'Add',
  inv_add_to_inventory: 'Add to inventory',
  inv_section_inventory: 'Inventory',
  inv_section_decks: 'Decks',
  decks_add_deck: 'Add deck',
  decks_empty_title: 'No decks yet',
  decks_empty_desc: 'Tap "Add to deck" to create your first deck and add cards.',
  decks_slots_label: 'User deck limit',
  decks_slots_value: '{used} / {limit}',
  decks_slots_unlimited: 'Unlimited decks (Pro)',
  decks_limit_reached: 'You reached the Free plan deck limit. Upgrade to Pro for unlimited decks.',
  decks_card_count: '{count} cards',
  decks_cards_in_deck: 'Cards in deck',
  decks_deck_value: 'Value',
  decks_missing_cards: 'Missing cards',
  decks_missing_cost: 'Cost',
  deck_rename_title: 'Rename deck',
  deck_rename_placeholder: 'Deck name',
  deck_menu_edit: 'Edit',
  deck_add_to_deck: 'Add to deck',
  deck_menu_delete: 'Delete',
  deck_delete_confirm_title: 'Delete deck?',
  deck_delete_confirm_msg: 'The deck “{name}” and the cards in it will be permanently deleted.',
  deck_edit_title: 'Edit deck',
  deck_edit_empty: 'No cards in this deck. Use “Add to deck” to add some.',
  deck_to_obtain_badge: 'Cards to obtain',
  inventory_summary_modal_button: 'View inventory summary',
  inventory_summary_title: 'Inventory summary',
  inventory_summary_total_cards: 'Cards in collection',
  inventory_summary_value: 'Value',
  inventory_summary_graded_cards: 'Graded cards',
  inventory_summary_ungraded_cards: 'Ungraded cards',
  inventory_summary_game_filter: 'Game',
  inventory_summary_all_games: 'All games',
  sealed_summary_total: 'Sealed products',
  sealed_summary_value: 'Value',
  inv_match_locked_warning: 'Card in an active match',
  inv_match_locked_warning_card: 'Card in an active match',
  inv_match_locked_warning_product: 'Product in an active match',

  // --- Wishlist ---
  wish_title: 'Wishlist',
  wish_empty_title: 'Your wishlist is empty',
  wish_empty_desc: 'Tap the "Addo to Wishlist" button to add the cards/sealed products you\'re looking for to get map matches.',
  wish_add: 'Add',
  wish_add_to_wishlist: 'Add to wishlist',

  // --- Catalog ---
  catalog_search: 'Search by name',
  catalog_results: '{count} results',
  catalog_binder: 'Binder',
  catalog_wishlist: 'Wishlist',
  catalog_add: 'Add',
  catalog_added_label: 'Added',
  catalog_remove: 'Remove',
  catalog_added_binder: '"{name}" added to binder',
  catalog_added_deck: '"{name}" added to deck',
  catalog_added_wish: '"{name}" added to wishlist',
  catalog_select_tcg: 'Select TCG',
  search_mode_expansion: 'Expansion',
  search_mode_card: 'Products',
  card_search_placeholder: 'Search product',
  card_search_empty: 'No products found.',

  // --- Matches / Chat ---
  matches_title: 'Your Matches',
  matches_empty_title: 'No matches yet',
  matches_empty_desc: 'Start discovering cards or sealed products in Discover to get your first match!',
  matches_section_outgoing: 'Sent',
  matches_section_incoming: 'Incoming',
  history_matches_section_outgoing: 'Sent',
  history_matches_section_incoming: 'Received',
  matches_unread_label: '{count} unread messages',
  chat_placeholder: 'Write a message…',
  matches_confirm: 'Confirm',
  matches_load_error: 'Unable to load matches. Check your connection and try again.',
  matches_load_error_title: 'Match loading error',
  matches_load_retry: 'Retry loading',
  matches_deep_link_not_found: 'This trade is no longer available.',
  chat_unavailable: 'Cannot send: invalid match or expired session.',
  chat_attachment_unsupported: 'Unsupported attachment format.',
  chat_attachment_too_large: 'File exceeds the 5 MB limit.',
  chat_attachment_too_many: 'You can attach at most {count} files per send.',
  chat_attachment_blocked_nsfw: 'Image blocked: explicit or potentially harmful content detected.',
  chat_attachment_blocked_text: 'Image blocked: it contains disallowed text.',
  chat_attachment_checking: 'Checking image…',
  chat_uploading: 'Uploading attachment…',

  // ── Chat: invio robusto, spunte, typing ──
  chat_send_failed: 'Send failed',
  chat_retry: 'Retry',
  chat_delete_failed: 'Delete',
  chat_sending: 'Sending',
  chat_sent: 'Sent',
  chat_read: 'Read',
  chat_new_messages_one: '1 new message',
  chat_new_messages: '{count} new messages',
  chat_typing: 'is typing…',
  chat_typing_named: '{name} is typing…',
  chat_propose_trade: 'Propose trade',
  chat_load_older: 'Load earlier messages',
  chat_attach_aria: 'Attach image or video',
  chat_send_aria: 'Send message',
  chat_remove_attachment_aria: 'Remove attachment',
  chat_lightbox_close_aria: 'Close image',

  // --- Notifications ---
  notifications_title: 'Notifications',
  notifications_empty: 'No new notifications',
  notification_new_match: 'New trade proposal.',
  notification_new_message: 'New message',
  notification_image: 'Image',
  notification_trade_proposed: 'Wants to trade with you',
  notification_trade_accepted: 'Accepted your trade: tap to open the history and leave a review',
  notification_trade_cancelled: 'Trade cancelled',
  notification_review_prompt: 'Leave a review on the trade you just completed',
  notification_review_received: 'You received a review',
  notification_pro_activated: 'Congratulations! Your Pro subscription is now active 🎉',
  notifications_view_title: 'Notification center',
  notifications_clear_all: 'Delete all notifications',
  notifications_nearby_summary: 'You have {count} new nearby trades · View in the Discover section',
  notification_match_deleted: 'Deleted the match with you',
  notification_account_deleted: 'Deleted their account: the match is no longer available',
  notifications_push_badge_title: 'Push notifications disabled',
  notifications_push_badge_desc: 'Enable push notifications to receive new matches and messages instantly.',
  notifications_push_activate: 'Enable',
  notifications_push_activating: 'Enabling…',
  notifications_push_enabled: 'Push notifications enabled.',
  notifications_push_enable_error: 'Unable to enable push notifications.',
  notifications_unknown_sender: 'User unavailable',

  // --- Reviews ---
  reviews_button: 'Reviews',
  history_leave_review_btn: 'Leave a review',
  reviews_empty: 'No reviews yet.',
  reviews_count: '{count} reviews',
  review_form_title_outgoing: 'Review {user}',
  review_form_title_incoming: 'Review {user}',
  review_form_rating_label: 'Rating',
  review_form_comment_label: 'Comment',
  review_form_comment_placeholder: 'Write a comment (optional)',
  review_comment_not_allowed: 'The comment contains disallowed words',
  review_form_submit: 'Send',
  review_form_cancel: 'Cancel',
  review_sent: 'Review sent',

  // ── Match partner report ──────────────────────────────────────────────────
  report_button: 'Report user',
  report_already: 'You already reported this match',
  report_form_title: 'Report {user}',
  report_form_title_three_way: 'Report in the three-way trade',
  report_form_intro: 'Use reporting only for a genuine incorrect completion of the trade. Unfounded reports lower your trust score and your ability to report in the future.',
  report_form_target_label: 'Who do you want to report?',
  report_target_already: 'Already reported',
  trust_badge_trusted: 'Trusted',
  trust_badge_trusted_desc: 'Completed trades with great reviews and no confirmed reports.',
  trust_badge_flagged: 'Low reliability',
  trust_badge_flagged_desc: 'Several different users reported issues completing trades.',
  report_form_reason_label: 'Reason',
  report_reason_no_show: 'Did not show up',
  report_reason_item_not_as_described: 'Card not as agreed',
  report_reason_incomplete_trade: 'Trade left unfinished',
  report_reason_abusive_behavior: 'Abusive behavior',
  report_reason_other: 'Other',
  report_form_comment_label: 'Details (optional)',
  report_form_comment_placeholder: 'Describe what happened…',
  report_form_ack: 'I confirm this report is truthful and made in good faith.',
  report_form_submit: 'Submit report',
  report_form_cancel: 'Cancel',
  report_comment_not_allowed: 'The comment contains disallowed words',
  report_rate_limited: 'You have reached the recent reporting limit. Please try again later.',
  report_submit_error: 'Could not submit the report. Please try again.',

  // --- Profile ---
  profile_title: 'Profile',
  profile_bio: 'Bio',
  profile_save: 'Save profile',
  profile_saved: 'Profile updated',
  profile_social_title: 'Public social links',
  profile_social_edit: 'Edit {social} profile',
  profile_social_confirm: 'Confirm social link',
  profile_social_invalid: 'Enter a valid Facebook, Instagram, or eBay link',
  profile_settings: 'Settings',
  profile_help: 'Guide',
  profile_location: 'Location',
  profile_donate_paypal: 'Donate with PayPal ❤️',
  profile_invite_friend: 'Invite a friend',

  // --- Referral / Invite a friend ---
  auth_referral_code_optional: 'Invite code (optional)',
  auth_referral_code_hint: 'Got a code from a friend? Enter it here.',
  invite_title: 'Invite a friend',
  invite_back_label: 'Go back',
  invite_eyebrow: 'Bring a friend to SwapWish',
  invite_heading: 'Invite a friend, get 7 days of Pro',
  invite_description: 'Share your code. When your friend downloads the app, signs up, joins the Telegram group and reaches their first active match, you get 7 days of Pro subscription.',
  invite_your_code: 'Your code',
  invite_share: 'Share invite',
  invite_share_message: 'Join me on SwapWish TCG and let\'s trade cards! Use my invite code:',
  invite_copied_toast: 'Invite copied to clipboard',
  invite_share_unsupported: 'Sharing is not available on this device',
  invite_list_title: 'Your invites',
  invite_loading: 'Loading…',
  invite_empty: 'You haven\'t invited anyone yet.',
  invite_pending_friend: 'Invited friend',
  invite_community_title: 'Telegram community',
  invite_community_desc: 'Join the official group: it\'s also used to validate invites.',
  invite_community_join: 'Join the community',
  invite_community_open: 'Open / finish joining',
  invite_community_joined: 'You\'re in the group',
  invite_status_pending: 'Pending',
  invite_status_registered: 'Registered',
  invite_status_joined_telegram: 'In Telegram group',
  invite_status_qualified: 'Qualified',
  invite_status_rewarded: 'Reward granted',
  invite_status_rejected: 'Invalid',
  profile_privacy: 'Privacy policy',
  profile_legal_section: 'Extra',
  profile_child_safety: 'Child safety',
  profile_terms: 'Terms of Service',
  profile_app_version: 'App version',

  // --- Privacy policy ---
  privacy_title: 'Privacy policy',
  privacy_intro: 'SwapWish TCG is an app for trading cards and sealed TCG products with people near you. This page explains which data we process, why, and with which services, in compliance with Regulation (EU) 2016/679 (GDPR).',
  privacy_last_update: 'Last updated: June 10, 2026',
  privacy_owner_title: 'Data controller',
  privacy_owner_desc: 'The data controller is the SwapWish TCG team, reachable at support@swapwishtcg.com. You can contact us at any time for any request about your data.',
  privacy_data_title: 'Data we collect',
  privacy_data_desc: 'We only process the data needed for the app to work:',
  privacy_data_account_title: 'Account',
  privacy_data_account_desc: 'email, username, first and last name, password (stored encrypted by our authentication provider) and any uploaded avatar.',
  privacy_data_location_title: 'Location',
  privacy_data_location_desc: 'GPS coordinates (if you grant geolocation) or the address you provide, used only to compute approximate distances from other users.',
  privacy_data_collection_title: 'Collection and wishlist',
  privacy_data_collection_desc: 'the cards and sealed products you declare to own or look for, with condition, language, grading and indicative price.',
  privacy_data_trades_title: 'Matches, trades and chat',
  privacy_data_trades_desc: 'generated matches, trade proposals, completed trades, reviews, reports and the messages (text and media) exchanged in chat with other users.',
  privacy_data_push_title: 'Push notifications',
  privacy_data_push_desc: 'the device token required to deliver notifications (new matches, proposals, accepted trades), if you enable them.',
  privacy_data_payments_title: 'Subscription and donations',
  privacy_data_payments_desc: 'the Pro subscription status and payment outcomes. Payment details (card, account) are handled exclusively by PayPal or the mobile stores and never reach our systems.',
  privacy_location_title: 'Geolocation',
  privacy_location_desc: 'Location is used only to show trade candidates within your chosen radius and approximate distances on the map. Your exact position is never shown to other users: markers are intentionally approximate.',
  privacy_location_note: 'You can revoke the geolocation permission at any time from your device settings: in that case the app will only use the address optionally set in your profile settings.',
  privacy_purpose_title: 'Purposes of processing',
  privacy_purpose_matching_title: 'Geographic matching',
  privacy_purpose_matching_desc: 'crossing users\' collections and wishlists within the set radius to propose compatible trades.',
  privacy_purpose_trades_title: 'Trade management',
  privacy_purpose_trades_desc: 'creating and tracking matches, proposals, three-way trades, history and reviews.',
  privacy_purpose_notifications_title: 'Notifications',
  privacy_purpose_notifications_desc: 'alerting you about new matches, received proposals, accepted trades and messages.',
  privacy_purpose_support_title: 'Support and safety',
  privacy_purpose_support_desc: 'answering support requests and preventing platform abuse.',
  privacy_third_title: 'Third-party services',
  privacy_third_desc: 'The app relies on selected external services:',
  privacy_third_supabase_title: 'Supabase',
  privacy_third_supabase_desc: 'authentication, database and storage (including avatars and chat media), on infrastructure in the European Union.',
  privacy_third_firebase_title: 'Google Firebase',
  privacy_third_firebase_desc: 'push notification delivery via Firebase Cloud Messaging (it only receives the device token).',
  privacy_third_paypal_title: 'PayPal and mobile stores',
  privacy_third_paypal_desc: 'donations via PayPal and Pro subscriptions via Google Play: payment details stay with PayPal/Google under their respective privacy policies.',
  privacy_third_catalogs_title: 'TCG catalogs and prices',
  privacy_third_catalogs_desc: 'CardTrader, TCGdex, pokemontcg.io, Scryfall, YGOPRODeck and eBay provide product catalogs and market prices: none of your personal data is sent to these services.',
  privacy_third_maps_title: 'OpenStreetMap',
  privacy_third_maps_desc: 'map tiles in the Discover section; map requests only contain the displayed area.',
  privacy_push_title: 'Push notifications',
  privacy_push_desc: 'Notifications are optional: you can disable them from your device or app settings. Once disabled, the device token is no longer used.',
  privacy_security_title: 'Security and retention',
  privacy_security_desc: 'Data travels encrypted (TLS) and database access is protected by row-level security policies: each user can only access their own data and what is strictly needed for trades (e.g. candidates\' public collections).',
  privacy_retention_desc: 'Data is kept while your account is active. When the account is deleted, personal data is removed; aggregate or anonymous trade statistics may be retained.',
  privacy_rights_title: 'Your rights (GDPR)',
  privacy_rights_desc: 'You can exercise the rights set out in articles 15-22 of the GDPR at any time:',
  privacy_rights_access_title: 'Access and portability',
  privacy_rights_access_desc: 'obtain a copy of your data in a readable format.',
  privacy_rights_rectify_title: 'Rectification',
  privacy_rights_rectify_desc: 'correct your profile data directly in the app (Profile and Settings) or through support.',
  privacy_rights_delete_title: 'Erasure',
  privacy_rights_delete_desc: 'request deletion of your account and associated data by writing to support.',
  privacy_rights_withdraw_title: 'Withdrawal of consent',
  privacy_rights_withdraw_desc: 'revoke geolocation and notifications from your device settings, without affecting processing already carried out.',
  privacy_minors_title: 'Minors',
  privacy_minors_desc: 'The app is not intended for children under 14. If you believe a minor has provided us personal data, contact us and we will remove it.',
  privacy_contact_title: 'Contact',
  privacy_contact_desc: 'For questions about this policy or to exercise your rights, write to support@swapwishtcg.com or use the in-app Support section.',
  privacy_changes_note: 'Any changes to this policy will be published on this page with the update date. Substantial changes will be announced in the app.',

  // --- Account deletion (public URL required by Google Play) ---
  del_title: 'Account deletion',
  del_intro: 'This page explains how to delete your SwapWish TCG account and all associated data. You can do it directly from the app or by sending a request via email.',
  del_last_update: 'Last updated: June 10, 2026',
  del_app_title: 'Delete your account from the app',
  del_app_desc: 'The fastest way is from within the app, where deletion is immediate and permanent:',
  del_app_step1: 'Open the app and sign in to your account.',
  del_app_step2: 'Go to Profile → Settings.',
  del_app_step3: 'At the bottom of the page tap "Delete account".',
  del_app_step4: 'Confirm: your account and all data are removed and any active Pro subscription is cancelled.',
  del_app_note: 'This action is irreversible: once confirmed, the account and its data cannot be recovered.',
  del_email_title: 'Request via email',
  del_email_desc: 'If you cannot access the app, you can request deletion by writing from the email address linked to your account to:',
  del_email_note: 'Include your account email. We will process the request within 30 days, after verifying your identity.',
  del_data_title: 'Data that is deleted',
  del_data_desc: 'Deleting your account permanently removes:',
  del_data_account: 'account data: email, username, first and last name, password and avatar;',
  del_data_collection: 'your collection and your wishlist;',
  del_data_trades: 'matches, trade proposals, completed trades and reviews;',
  del_data_messages: 'messages and media exchanged in chats;',
  del_data_location: 'saved location and address;',
  del_data_subscription: 'subscription data (any active Pro subscription is cancelled at the store);',
  del_data_files: 'uploaded files (avatar and chat attachments).',
  del_retained_title: 'Retained data and timing',
  del_retained_desc: 'Personal data is deleted immediately when removed from the app, or within 30 days for email requests. We may retain only aggregated or anonymized statistical data that cannot be traced back to your identity, along with any records required by law (e.g. payment receipts) for the period mandated by regulations.',
  del_timing_desc: 'Payment data is never stored on our systems: it is handled by PayPal and the mobile stores under their respective policies.',

  // --- Child safety standards (public CSAE URL required by Google Play) ---
  cs_title: 'Child safety standards',
  cs_intro: 'SwapWish TCG enforces a zero-tolerance policy against child sexual abuse and exploitation (CSAE). These standards, published in accordance with the Google Play child safety standards policy, describe what is prohibited, how to report, and how we respond.',
  cs_last_update: 'Last updated: June 10, 2026',
  cs_prohibited_title: 'Absolute prohibition of CSAE',
  cs_prohibited_desc: 'Using SwapWish TCG for any content or conduct related to child sexual abuse or exploitation is strictly prohibited, including:',
  cs_prohibited_csam: 'child sexual abuse material (CSAM) in any form, including digitally generated or altered material;',
  cs_prohibited_grooming: 'child grooming: any contact aimed at abusing or exploiting a minor;',
  cs_prohibited_sextortion: 'sextortion: sexual threats or blackmail targeting minors;',
  cs_prohibited_sexualization: 'any sexualization of minors, including text, images, or requests in chats.',
  cs_age_title: 'Minimum age',
  cs_age_desc: 'The app is not intended for children under 14. Accounts found to belong to users below the minimum age are removed. If you believe a minor is using the platform, please report it to us.',
  cs_report_title: 'How to report',
  cs_report_desc: 'You can report suspicious content or behavior directly from the app via Settings → Support, or by writing to the dedicated point of contact:',
  cs_report_note: 'Reports concerning child safety are reviewed with the highest priority. In case of immediate danger, always contact law enforcement first.',
  cs_actions_title: 'How we respond',
  cs_actions_desc: 'When a violation of these standards is confirmed:',
  cs_actions_remove: 'the content is removed immediately;',
  cs_actions_ban: 'the responsible account is permanently terminated;',
  cs_actions_authorities: 'the case is reported to the competent authorities (in Italy the Postal Police and, where applicable, NCMEC);',
  cs_actions_preserve: 'evidence is preserved within the limits of the law to support investigations.',
  cs_law_title: 'Legal compliance',
  cs_law_desc: 'SwapWish TCG complies with applicable child safety laws, including Italian and EU regulations and the related reporting obligations, as well as the Google Play child safety standards.',
  cs_contact_title: 'Designated point of contact',
  cs_contact_desc: 'The designated child safety point of contact, prepared to handle CSAE-related communications, can be reached at support@swapwishtcg.com.',

  // --- Terms of Service (public /terms route) ---
  tos_title: 'Terms of Service',
  tos_intro: 'These terms govern your use of SwapWish TCG. By creating an account or using the app you fully accept them: please read them carefully.',
  tos_last_update: 'Last updated: June 10, 2026',
  tos_service_title: 'The service',
  tos_service_desc: 'SwapWish TCG is a platform that connects collectors of trading cards and sealed products for in-person trades, by matching users\' collections, wishlists, and locations.',
  tos_service_note: 'The app is not a party to any trade: it does not sell products, does not handle payments between users, and does not act as an intermediary or guarantor of transactions.',
  tos_account_title: 'Account',
  tos_account_desc: 'To use the app you must be at least 14 years old and provide truthful information. You are responsible for keeping your credentials safe and for everything that happens through your account. Only one account per person is allowed.',
  tos_conduct_title: 'Code of conduct',
  tos_conduct_desc: 'By using the platform you agree NOT to:',
  tos_conduct_fraud: 'commit fraud, scams, or propose trades you do not intend to honor;',
  tos_conduct_fakes: 'offer counterfeit, altered, or illegally sourced cards or products;',
  tos_conduct_offensive: 'post illegal, offensive, harassing, or discriminatory content, in chats or on your profile;',
  tos_conduct_commercial: 'use the app for unauthorized commercial activities or spam;',
  tos_conduct_abuse: 'manipulate the system (multiple accounts, bots, scraping, fake reviews or baseless reports against other users).',
  tos_trades_title: 'Trades between users',
  tos_trades_desc: 'Trades take place directly between users, who are solely responsible for them:',
  tos_trades_verify: 'verify the authenticity and condition of products in person before completing the trade;',
  tos_trades_meet: 'choose public, busy places for meet-ups;',
  tos_trades_reviews: 'leave honest reviews: they help the community trade safely;',
  tos_trades_no_warranty: 'SwapWish does not guarantee the outcome, quality, or value of trades; displayed prices are indicative market estimates.',
  tos_pro_title: 'Pro subscription',
  tos_pro_desc: 'The Pro subscription is billed through Google Play and renews automatically until cancelled in Google Play → Payments & subscriptions. Deleting your account cancels any active subscription. Prices and offer contents may change with reasonable notice.',
  tos_ip_title: 'Content and intellectual property',
  tos_ip_desc: 'You retain ownership of the content you upload (avatar, photos, messages) and grant SwapWish the license needed to display it in the app. Names, logos, and images of card games belong to their respective owners: SwapWish TCG is not affiliated with, sponsored, or endorsed by any TCG publisher.',
  tos_ip_note: 'Catalog data and prices come from third-party providers and are offered without any guarantee of completeness or accuracy.',
  tos_liability_title: 'Liability and account termination',
  tos_liability_desc: 'The service is provided "as is", with no guarantee of continuous availability or absence of errors. To the extent permitted by law, SwapWish is not liable for damages arising from trades between users, service unavailability, or catalog and price inaccuracies.',
  tos_termination_desc: 'You can delete your account at any time from Settings or the account deletion page. If you violate these terms we may suspend or terminate your account, without notice in serious cases.',
  tos_law_title: 'Governing law and contact',
  tos_law_desc: 'These terms are governed by Italian law; consumer disputes fall under the jurisdiction of the user\'s place of residence. For any questions write to support@swapwishtcg.com.',
  tos_changes_note: 'Any changes to these terms will be published on this page with the update date. Substantial changes will be announced in the app.',
  profile_logout: 'Log out',
  profile_info_section: 'Profile information',
  profile_other_section: 'Other',
  profile_change_photo: 'Change photo',
  profile_avatar_alt: 'Profile avatar',
  profile_edit_username: 'Edit username',
  profile_save_username: 'Save username',
  profile_cancel_username: 'Cancel',
  profile_username_not_allowed: 'The username contains disallowed words',
  profile_share: 'Share profile',
  profile_share_message: 'Check out my inventory and wishlist on SwapWish TCG!',
  profile_share_copied: 'Link copied to clipboard',
  profile_share_error: 'Sharing failed',
  shared_profile_loading: 'Loading…',
  shared_profile_not_found_title: 'Profile unavailable',
  shared_profile_not_found_desc: 'This share link is no longer valid.',
  shared_profile_inventory: 'Tradeable inventory',
  shared_profile_wishlist: 'Wishlist',
  shared_profile_empty_inventory: 'No tradeable cards.',
  shared_profile_empty_wishlist: 'No cards in wishlist.',
  shared_profile_cta: 'Discover SwapWish TCG',
  profile_username_taken: 'This username is already taken',

  // --- Help ---
  // ── Per-view first-use intro popups ──────────────────────────────────────
  intro_eyebrow: 'Quick guide',
  intro_got_it: 'Got it!',
  intro_discover_title: 'Discover',
  intro_discover_bullets: [
    'The map shows collectors within your range: indigo dots are matches (mutual trades or collectors who have something you want), the lighter purple dots are other nearby users with at least one card.',
    'Tap a match to see what can be traded and start a Match. On a user without matches you pick the cards to request yourself: we add them temporarily to your Wishlist and you set quantities and a cash amount in Trades (the cards leave the Wishlist once the trade completes or is deleted).',
    'In the details, tap the user name to open their profile with Binder, Wishlist, history, and reviews; when there are no cards in return you can offer a cash amount.',
    'The List button opens All / Compatible and, with Pro, Three-way trades as the third section (All by default); the 👑 button opens the Trade Leaderboard. From Filters you adjust the range (up to 25 km Free, 500 km Pro) and pick the TCG: an active location or a saved address is required, and your exact position stays private.',
    '🔒 Pro: filters by condition, language and grading, combined matchmaking by selecting multiple TCGs in Filters (also to propose cards from different games), three-way trades A → B → C → A, and push alerts for new candidates in range.',
  ],
  intro_inventory_title: 'Binder',
  intro_inventory_bullets: [
    'This is your digital binder: expansions are grouped, showing the number of cards and sealed products.',
    'Tap an expansion to add cards with condition, language, quantity, grading, and variant — also via camera scan, search by name, or bulk import (Settings).',
    'Items involved in an active Match stay locked and cannot be edited or reused until the Match is resolved.',
    'Use the Inventory/Decks selector to build your decks (3 free, unlimited with Pro); the summary shows Binder quantities and value.',
  ],
  intro_wishlist_title: 'Wishlist',
  intro_wishlist_bullets: [
    'Add the cards and sealed products you are looking for: this is what the system uses to find your matches.',
    'The more precise it is (condition, language, variant), the more relevant the matches.',
    'When a proposal is accepted, traded quantities update automatically; edit it manually for purchases or trades completed outside the app.',
  ],
  intro_matches_title: 'Matches',
  intro_matches_bullets: [
    'Outgoing, Incoming, and three-way trades each have their own tab; a received three-way proposal remains available to Free participants.',
    'On the map, “Send proposal” saves a three-way draft: open Details and send it from the Three-way tab.',
    'Tap the row to agree in chat (photos too), or agree in person; only then use Details to choose items and quantities and send or accept the proposal.',
    'Items in a pending proposal are reserved.',
    'Completed trades move to History, where you can leave a review.',
  ],
  intro_detailsModal_title: 'Trade details',
  intro_detailsModal_bullets: [
    'On the left the cards you offer, on the right the ones you receive.',
    'Use the +/- selectors to choose how many copies to trade.',
    'Under each column total you can add a cash amount ($), useful when one side puts up only money.',
    'Use Send trade or Accept trade next to Close; after the action, tap the Waiting badge to reopen the details in read-only mode.',
  ],
  intro_profile_title: 'Profile',
  intro_profile_bullets: [
    'Edit your username, avatar, and public social links; you can also share your tradeable Binder and Wishlist with a link.',
    'From Settings, manage your default game, address, bulk import, and on mobile, notifications and the Pro subscription.',
    'View received reviews and open Guide and Contacts here; Trade History opens from the clock icon in Matches.',
  ],
  intro_catalog_title: 'Catalog',
  intro_catalog_bullets: [
    'Browse all expansions of the game, with cards, sealed products, and card numbers on the tiles.',
    'Search an expansion by name, or switch to Products to find a single card. For Pokémon, expansions are split into Western and Eastern.',
    'Open an expansion to add products to your inventory or wishlist, with market prices.',
  ],

  // ── Guided tour (replaces the automatic "Quick guide" popups) ─────────────
  tour_progress: 'Step {current} of {total}',
  tour_next: 'Next',
  tour_back: 'Back',
  tour_skip: 'Skip tour',
  tour_finish: 'Done',
  tour_welcome_eyebrow: 'The SwapWish Team',
  tour_welcome_title: 'Welcome to SwapWish!',
  tour_welcome_message: "You're all set: the map is your starting point to discover nearby collectors and begin trading.",
  // Sentence with a clickable "Guide" badge (→ Guide view in Settings): before +
  // <badge> + after, so the badge is an interactive element within the text.
  tour_welcome_guide_before: 'From your Profile, with the',
  tour_welcome_guide_after: "button, you'll find a detailed explanation of the platform. Happy trading!",

  tour_discover_intro_title: 'Discover who trades near you',
  tour_discover_intro_text: 'The map shows compatible collectors within your radius. Your exact location stays private: an approximate point of about 1 km is used.',
  tour_discover_map_title: 'The candidates map',
  tour_discover_map_text: 'Each dot is a collector you can trade with: tap it to see what they offer and start a Match.',
  tour_discover_filters_title: 'Radius and filters',
  tour_discover_filters_text: 'Here you adjust the range (up to 25 km on the Free plan, 500 km with Pro) and pick the TCG to search in. With Pro you unlock condition, language and grading filters and combined matchmaking across multiple TCGs.',
  tour_discover_candidates_title: 'Candidates list',
  tour_discover_candidates_text: 'Prefer a list to the map? Here you find all nearby candidates, with a badge for new arrivals.',
  tour_discover_leaderboard_title: 'Trade leaderboard',
  tour_discover_leaderboard_text: 'The crown opens the ranking of the most active nearby collectors by trades and reviews.',
  tour_discover_tournaments_title: 'Tournaments near you',
  tour_discover_tournaments_text: 'Verified profiles host tournaments: spot them by the yellow dot on the map and the Tournaments button, which lists the events within your radius.',
  tour_discover_to_inventory_title: 'Your Collection',
  tour_discover_to_inventory_text: "Let's move to the Collection: your digital binder of cards and sealed products.",

  tour_inventory_intro_title: 'Your digital binder',
  tour_inventory_intro_text: 'Here your expansions are grouped with the number of cards and sealed products you own.',
  tour_inventory_scan_title: 'Add with the camera',
  tour_inventory_scan_text: 'Point at a card to recognise it and add it on the fly, without searching by hand.',
  tour_inventory_add_title: 'Add manually',
  tour_inventory_add_text: 'Add cards and sealed choosing condition, language, quantity, grading and variant.',
  tour_inventory_filters_title: 'Search and filter',
  tour_inventory_filters_text: 'Quickly find an expansion or card, and switch between Inventory and Decks.',
  tour_inventory_summary_title: 'Collection summary',
  tour_inventory_summary_text: 'Check quantities and estimated value. Items committed to an active Match stay locked until it is resolved.',
  tour_inventory_to_wishlist_title: 'Your Wishlist',
  tour_inventory_to_wishlist_text: "Now let's look at the Wishlist: the cards and products you are looking for.",

  tour_wishlist_intro_title: 'What you are looking for',
  tour_wishlist_intro_text: 'Add the cards and sealed you want: it is the basis the system uses to find your matches.',
  tour_wishlist_add_title: 'Add to Wishlist',
  tour_wishlist_add_text: 'The more precise you are on condition, language and variant, the more relevant the matches will be.',
  tour_wishlist_filters_title: 'Search and filter',
  tour_wishlist_filters_text: 'When a proposal is accepted quantities update automatically; you can edit them by hand for purchases made outside the app.',

  tour_catalog_intro_title: 'The game Catalog',
  tour_catalog_intro_text: 'Browse all expansions with cards, sealed products and market prices.',
  tour_catalog_search_title: 'Search the catalog',
  tour_catalog_search_text: 'Find an expansion by name or switch to Products to search for a single card.',
  tour_catalog_grid_title: 'Open an expansion',
  tour_catalog_grid_text: 'From here you add products to your Collection or Wishlist, with up-to-date prices.',
  tour_catalog_to_matches_title: 'Your Matches',
  tour_catalog_to_matches_text: "Let's go to Matches: where trades are created and managed.",

  tour_matches_intro_title: 'Manage your trades',
  tour_matches_intro_text: 'Sent, incoming and three-way matches are organised in separate tabs.',
  tour_matches_tabs_title: 'The Match tabs',
  tour_matches_tabs_text: 'Open Details to choose items and quantities and send or accept; tap the row for chat. Items in a pending proposal stay reserved.',
  tour_matches_history_title: 'History and reviews',
  tour_matches_history_text: 'Completed trades end up here, where you can leave a review for your partner.',
  tour_matches_to_profile_title: 'Your Profile',
  tour_matches_to_profile_text: 'Last stop: your Profile and its settings.',

  tour_profile_intro_title: 'Your Profile',
  tour_profile_intro_text: 'Customise username, avatar and social links, and share your tradable Collection and Wishlist with a link.',
  tour_profile_settings_title: 'Settings',
  tour_profile_settings_text: 'Manage default game, address, bulk import and, on mobile, notifications and the Pro subscription.',
  tour_profile_help_title: 'Help and support',
  tour_profile_help_text: 'Here you always find this guide, the reviews you received and the contacts for any question.',

  // Pro-feature badge in the tour tooltip.
  tour_pro_badge: 'Pro',
  // Sections described from their entry button (the tour does not enter the
  // views, which may be empty): the text explains what the section shows on tap.
  tour_nav_inventory_title: 'Your Binder',
  tour_nav_inventory_text: 'The Binder opens your digital collection: the cards and the sealed products you own and want to trade.',
  tour_nav_wishlist_title: 'Your Wishlist',
  tour_nav_wishlist_text: 'The Wishlist opens what you are looking for: the cards and sealed you want. It is the basis the system uses to find your matches on the map.',
  tour_nav_matches_title: 'Your Matches',
  tour_nav_matches_text: 'The Matches opens your trades: sent and incoming proposals, three-way trades (Pro) and the chat to arrange them. History holds completed trades and reviews.',
  tour_nav_profile_title: 'Your Profile',
  tour_nav_profile_text: 'The Profile opens settings (default game, address, subscription), sharing of your Binder and Wishlist via a link, and this guide.',

  help_hero_desc: 'The platform built for TCG card collectors who want to trade safely, directly, and without complications.',
  help_in_person_title: 'Why trade in person?',
  help_in_person_desc: 'Shipping brings real risks: cards or sealed products damaged in transit, lost packages, and scams that are hard to dispute. SwapWish is designed to remove them.',
  help_in_person_transport_title: 'No transport risk',
  help_in_person_transport_desc: 'see the cards or sealed products live before handing yours over, with no surprises.',
  help_in_person_direct_title: 'Direct collector-to-collector trades',
  help_in_person_direct_desc: 'no middlemen, no payment platform, no fees.',
  help_in_person_mutual_title: 'Useful matches (cash too)',
  help_in_person_mutual_desc: 'a match appears when both collectors have something to gain, or when the other has a card you want: in that case you can propose a trade with a cash amount.',
  help_in_person_events_title: 'Great for fairs and events',
  help_in_person_events_desc: 'with Pro, increase your range to find distant collectors and agree on trades before the event.',
  help_sections_title: 'App sections',
  help_section_discover_desc: 'See compatible collectors on the map within your range.',
  help_section_discover_b1: 'Tap a circle to see what can be traded and start a Match.',
  help_section_discover_b2: 'In the details, tap the user name to open their profile: Binder, Wishlist, history, and reviews.',
  help_section_discover_b3: 'The List button shows every nearby candidate.',
  help_section_discover_b4: 'The crown opens the Leaderboard of nearby users with completed trades.',
  help_section_discover_b5: 'Filters adjusts the range and the TCG to search in; with Pro it unlocks product condition, language and grading, combined matchmaking by selecting multiple TCGs, and three-way trades.',
  help_section_discover_b6: 'Some matches (direct or three-way) include a cash amount set before sending; payment happens in person, outside the app.',
  help_section_inventory_desc: 'Your digital binder.',
  help_section_inventory_b1: 'Add cards or sealed products to trade with condition, language, quantity, grading, and variant.',
  help_section_inventory_b2: 'Add them by browsing the catalog, searching by name, or using the live camera scan.',
  help_section_inventory_b3: 'Each tile shows the card number and market prices.',
  help_section_inventory_b4: "Items involved in an active Match can't be edited or reused until the Match is resolved.",
  help_section_inventory_b5: "From Inventory/Decks you create private decks (3 free, unlimited with Pro), which don't affect trades.",
  help_section_wishlist_desc: 'The products you are looking for are the basis of map matching.',
  help_section_wishlist_b1: 'The more precise your Wishlist (minimum accepted condition, language, variant), the more relevant the matches.',
  help_section_wishlist_b2: 'When a proposal is accepted, traded quantities update automatically.',
  help_section_wishlist_b3: 'Edit them manually only for changes made outside the app.',
  help_section_matches_desc: 'Here you find Matches you created (Outgoing), received (Incoming), and three-way trades.',
  help_section_matches_b1: '“Send proposal” on the map saves a three-way draft: open Details in the Three-way tab, complete it, and send it there.',
  help_section_matches_b2: 'Search and creation require Pro; Free participants can open and respond to proposals they receive.',
  help_section_matches_b3: 'Tap a row for chat; after agreeing in chat or in person, use Details to choose items and quantities, then Send trade or Accept trade next to Close. The Waiting badge reopens the details in read-only mode.',
  help_section_matches_b4: 'Proposed items stay reserved until the trade is resolved.',
  help_section_matches_b5: 'Acceptance updates Binder and Wishlist and moves the trade to History (clock icon).',
  help_section_matches_b6: 'If included, the cash amount is set before sending and paid in person, outside the app.',
  help_section_profile_desc: 'Customize your public profile and access settings.',
  help_section_profile_b1: 'Edit your username, avatar, and public social links.',
  help_section_profile_b2: 'Share your tradeable Binder and Wishlist via a link.',
  help_section_profile_b3: 'View the reviews you received.',
  help_section_profile_b4: 'Open Settings: default game, address, CardTrader/Cardmarket/TCGplayer import, Pro mobile notifications, and subscription.',
  help_section_profile_b5: 'Access Guide and Contacts.',
  help_section_profile_b6: 'Completed Trade History opens from Matches instead.',
  help_section_catalog_desc: 'Opens when adding products from Binder or Wishlist.',
  help_section_catalog_b1: 'Holds every expansion of each game with cards, sealed products, and market prices.',
  help_section_catalog_b2: 'For Pokémon, separate Western/Eastern sections.',
  help_section_catalog_b3: 'Search for an expansion by name, or for a single card across the whole game with Products search.',
  help_swipe_title: 'How the map works',
  help_swipe_desc: 'Discover does not show random users: it automatically applies compatibility criteria and places only profiles with a possible trade on the map.',
  help_swipe_mutual_title: 'Compatibility and cash',
  help_swipe_mutual_desc: "your wishlist is matched against other collectors' binders and, in parallel, their wishlist is matched against your binder. Mutually useful profiles appear, plus collectors who have a card from your wishlist even if they want nothing from your binder: in that case the trade can be settled with a cash amount entered in the details.",
  help_swipe_radius_title: 'Geographic range',
  help_swipe_radius_desc: 'you only see profiles within your range, adjustable from the Filters button in Discover: up to 25 km on the Free plan, up to 500 km with Pro.',
  help_swipe_pro_filters_title: 'Pro filters',
  help_swipe_pro_filters_desc: 'you can narrow matches by condition, language, grading company, and grade. Filters are saved on your device and applied to the next search.',
  help_swipe_identity_title: 'Card identity criteria',
  help_swipe_identity_desc: 'the system considers card, condition, language, grading, and variant to keep matches relevant.',
  help_swipe_dismiss_title: 'Removing a match suggestion',
  help_swipe_dismiss_desc: 'in the candidates list, swipe a suggestion to the left to remove it: it will not be proposed again until one of the two users has at least one new card compared to the previous result.',
  help_map_filter_title: 'All / Compatible / Three-way',
  help_map_filter_desc: 'at the top of the candidates list, choose "Compatible" to see only users you already match with, or "All" to include other nearby users with at least one card. With Pro, "Three-way trades" is the third section and contains useful three-person cycles.',
  help_map_compose_title: 'Proposing to users without matches',
  help_map_compose_desc: 'tap a user without matches to pick cards from their collection yourself (even across games if you are Pro with multiple games in the filter); you set quantities and a cash amount or extra in the Trades tab.',
  help_map_wishlist_autoadd_title: 'Cards added to your wishlist',
  help_map_wishlist_autoadd_desc: 'the cards you pick are automatically added to your wishlist to handle the trade, and removed when the trade completes or is deleted.',
  help_match_title: 'How a Match works',
  help_match_positive_title: 'Positive match',
  help_match_positive_desc: 'tap Trade in the details of a compatible candidate; the new Match appears under Outgoing.',
  help_match_chat_title: 'Chat',
  help_match_chat_desc: 'tap the match row and agree on how many items to trade, which items, and where and when to meet.',
  help_match_proposal_title: 'Formal proposal',
  help_match_proposal_desc: 'after agreeing in chat or in person, open Details: the sender uses Send trade and the recipient uses Accept trade, both next to the modal Close button. After the action, the Waiting badge reopens the proposal in read-only mode.',
  help_match_in_person_title: 'In-person trade',
  help_match_in_person_desc: 'meet up, exchange the cards/sealed products by hand, and the match is closed.',
  help_match_delete_title: 'Deleting a match',
  help_match_delete_desc: 'if you delete a match, the search will not propose the same pairing again: it becomes visible only when one of the two users has something new and compatible that was not part of the previous result.',
  help_match_note: 'Cards or sealed products included in a pending proposal are locked and cannot be selected in other matches until that proposal is resolved. Additionally, while you have an active match with a user, that user does not appear among the candidates on the map: they become visible again only once the trade completes or is deleted.',
  help_pro_title: 'Why go Pro?',
  help_pro_desc: 'SwapWish Pro unlocks advanced features for collectors who trade frequently, across longer distances, or across multiple games.',
  help_pro_radius_title: 'Range up to 500 km',
  help_pro_radius_desc: 'perfect for events, fairs, and conventions outside your area. The Free plan limit is 25 km.',
  help_pro_slots_title: 'Unlimited Binder and Wishlist slots',
  help_pro_slots_desc: 'the Free plan shares 25 quantity-based slots between Binder and Wishlist; Pro removes the limit.',
  help_pro_three_way_title: 'Three-way trades (A → B → C → A)',
  help_pro_three_way_desc: 'on the map you find circular trades between three users: you give to B, B gives to C, and C gives to you. Complete cycles and cash bridges with real added value are shown; if B and C are both already direct candidates and you would have to pay B, the cycle is excluded because a direct trade with cash, including cash plus cards or products, is enough. Tap a trade to see every step. Then create the draft (1/3), choose quantities and amount in Matches (2/3), and send it (3/3). While active, its participants do not appear among direct trades.',
  help_pro_filters_title: 'Advanced Discover filters',
  help_pro_filters_desc: 'narrow your search by condition, language, grading company, and grade directly from the Filters button.',
  help_pro_multi_tcg_title: 'Multi-TCG search',
  help_pro_multi_tcg_desc: 'select multiple TCGs from the Filters button to extend the search to several games at the same time, even outside the default game.',
  help_pro_visibility_title: 'More visibility',
  help_pro_visibility_desc: 'your profile is prioritized in the compatible candidate list and displays the Pro badge.',
  help_pro_nearby_title: 'Real-time nearby trade alerts',
  help_pro_nearby_desc: 'Every 5 minutes SwapWish looks for new compatible candidates within your configured range. When a new one appears, even with the app closed, you receive one push notification that opens Discover, where you can start the Match. Known candidates do not trigger repeated alerts, and Free users who reached the 4-active-Match cap are excluded. Available in the mobile app and requires background location and push notifications.',
  help_report_title: 'Reports and trust',
  help_report_desc: 'From the chat of an active trade you can report a partner who fails to complete the trade correctly. The tool is designed to be useful but hard to abuse.',
  help_report_how_title: 'How to report',
  help_report_how_desc: 'tap the flag icon at the top right of the chat and pick a reason (no-show, card not as agreed, unfinished trade, abusive behavior). In three-way trades you can choose which of the two participants to report, or both.',
  help_report_limit_title: 'One per user, with a cap',
  help_report_limit_desc: 'you can send only one report per user in that trade and just a small number of reports within a few days: reporting has a cost, so spamming does not pay off.',
  help_report_weight_title: 'Patterns matter, not a single vote',
  help_report_weight_desc: 'a single report never penalizes anyone. The system acts only when several different users report the same person, giving more weight to reports from trustworthy users and less to serial reporters.',
  help_report_privacy_title: 'Confidentiality',
  help_report_privacy_desc: 'reports are confidential: the reported user does not know who reported them, so retaliation is not possible.',
  help_report_badge_title: 'Reliability badge',
  help_report_badge_desc: 'a badge can appear on profiles and reviews: “Trusted” for users with great reviews and no confirmed reports, or “Low reliability” only when several different users have reported issues.',
  help_support_title: 'Need help?',
  help_support_desc: 'For issues, reports, or suggestions, use Contacts in Profile or email {email}: we reply as soon as possible.',

  // --- Nearby trade alerts ---
  nearby_alert_title: 'Nearby trade available',
  nearby_alert_subtitle: '{user} at {distance} km · View the details in the Discover section',
  nearby_alert_section_title: 'Near you',
  nearby_alert_claim_cta: 'Start trade',
  nearby_alert_claim_error_already_claimed: 'Another user already started this trade.',
  nearby_alert_claim_error_free_cap: 'The counterparty has reached the Free plan limit of active trades.',
  nearby_alert_push_title: 'Nearby trade available',
  nearby_alert_push_body: 'View the details in the Discover section.',
  bg_geo_title: 'SwapWish',
  bg_geo_notice: 'Keeping your approximate position up to date for matches.',

  // --- Settings ---
  settings_title: 'Settings',
  settings_language: 'Language',
  settings_language_it: 'Italiano',
  settings_language_en: 'English',
  settings_radius: 'Trade range',
  settings_radius_desc: 'We only show cards within {radius} km of you.',
  settings_radius_free: 'The Free plan is limited to 25 km.',
  settings_go_pro: 'Upgrade to SwapWish Pro',
  settings_pro_desc: 'Range up to 500 km, unlimited slots and three-way trades.',
  settings_three_way: 'Three-way trades',
  settings_three_way_desc: 'Circular three-way trade suggestions (A → B → C → A) to break deadlocks.',
  settings_pro_only: '(Pro only)',
  settings_update_loc: 'Update location',
  settings_update_loc_desc: 'Your exact location is never stored, only an approximation.',

  // --- Subscription ---
  sub_title: 'SwapWish Pro',
  sub_price: '1,99',
  sub_period: '/month',
  sub_subtitle: 'Unlock advanced search, wider range, and sharper trade controls.',
  sub_already_pro: 'You\'re already a Pro user!',
  sub_activated_button: 'Subscription activated',
  sub_pay_app_store: 'Subscribe with Apple App Store',
  sub_pay_app_store_loading: 'Opening App Store',
  sub_pay_play_store: 'Subscribe with Google Play',
  sub_pay_play_store_loading: 'Opening Google Play',
  sub_mobile_only_message: 'Pro purchase is available only on mobile app (iOS/Android) via store.',
  sub_store_redirected_notice: 'Redirecting you to the store to complete payment.',
  sub_store_error: 'Unable to start store payment flow. Please try again.',
  sub_play_billing_unavailable: 'Google Play billing is unavailable in this app version. Update the app from Google Play and try again.',
  sub_verify_access_denied: 'Google Play is not configured to verify this purchase. Please try again later or contact support.',
  sub_verify_purchase_pending: 'Google Play has not made this purchase available for verification yet. Close and reopen the app in a few seconds; the subscription will complete automatically.',
  sub_verify_error: 'Unable to verify the purchase with Google Play. Please try again later.',
  sub_legal: 'By subscribing you accept the Terms of Service. You can cancel anytime from your store account settings.',
  sub_renewal_notice: 'Pro is a monthly subscription with automatic monthly renewal unless cancelled before renewal.',
  sub_features: [
    'Range up to 500 km',
    'Real-time nearby trade alerts (within your search range)',
    'Unlimited inventory slots',
    'Unlimited decks',
    'Advanced Discover filters: condition, language, grading and grade',
    'Combined matchmaking across multiple TCGs',
    'Visibility boost for your cards',
    'Circular three-way trade suggestions (A → B → C → A)',
    'Pro profile badge',
  ],

  // --- Three-way trades ---
  three_title: 'Three-Way Trades',
  three_pro_gate_title: 'Pro Feature',
  three_pro_gate_desc: 'Three-way trade suggestions (A → B → C → A) are only available for Pro users and are shown on the map.',
  three_intro: 'Circular trade: <strong>you</strong> give a card to <strong>B</strong>, <strong>B</strong> gives one to <strong>C</strong> and <strong>C</strong> gives one to <strong>you</strong>.',
  three_empty_title: 'No three-way trades found',
  three_empty_desc: 'There are no three-way trades within your range at the moment. Add more cards to your wishlist and binder to improve your chances!',
  three_propose: 'Propose this trade',
  three_proposed: 'Three-way trade proposed!',
  three_create_match: 'Send proposal',
  three_way_match_created: 'Draft created (1/3). Now choose quantities and amount (2/3), then send the proposal (3/3).',
  three_you: 'You',
  three_distances: 'Distances: {d1}km + {d2}km',

  // --- Card condition ---
  cond_mint: 'M',
  cond_near_mint: 'NM',
  cond_excellent: 'EX',
  cond_good: 'GD',
  cond_light_played: 'LP',
  cond_played: 'PL',
  cond_poor: 'PO',

  // --- Filter bar (Inventory / Wishlist) ---
  filter_name_placeholder: 'Card name',
  filter_card_placeholder: 'Search card',
  filter_sealed_placeholder: 'Search product',
  filter_number_placeholder: '#  Number',
  filter_expansion_placeholder: 'Expansion',
  filter_product_type_placeholder: 'Category',
  filter_results: '{count} of {total}',
  filter_no_results: 'No cards match your search.',

  // --- Sealed product categories ---
  sealed_category_booster_pack: 'Booster Pack',
  sealed_category_booster_box: 'Booster Box',
  sealed_category_elite_trainer_box: 'Elite Trainer Box',
  sealed_category_collection_box: 'Collection Box',
  sealed_category_deck: 'Deck',
  sealed_category_tin: 'Tin',
  sealed_category_bundle: 'Bundle',
  sealed_category_case: 'Case',
  sealed_category_accessory: 'Accessory',
  sealed_category_other: 'Other',

  // --- Radius edit sheet (Discover) ---
  swipe_radius_title: 'Search range',
  swipe_radius_loading: 'Applying range and loading new matches…',

  // --- Settings: address update ---
  settings_update_address_desc: 'Change the location used to calculate distances.',
  settings_address_saved: 'Address updated',
  settings_current_address_label: 'Saved address',
  settings_current_address_none: 'No address saved',

  // --- Mandatory default address ---
  address_required_title: 'Default address required',
  address_required_message: 'To use SwapWish you need to set a default address in Settings: it is the location used to find nearby matches when GPS is off or you are offline. Neither your address nor your GPS position is ever made public — other users only see an approximate position of about 1 km.',
  address_required_cta: 'Go to Settings',
  settings_address_required_banner: 'Set a default address to continue. It will never be made public: only an approximate position of about 1 km is used on the map.',

  // --- Settings: default game ---
  settings_default_game: 'Default game',
  settings_default_game_desc: 'Pre-selects the game filter.',
  settings_default_game_none: 'All games',
  settings_default_game_save_error: 'Unable to save the default game. Please try again.',

  // --- Onboarding ---
  onboarding_game_title: 'Choose your game',
  onboarding_game_info: 'You can change your default game anytime from Settings.',
  onboarding_game_save_error: 'Unable to save the game to your profile. Check your connection and try again.',
  onboarding_skip: 'Skip',
  onboarding_next: 'Next',
  onboarding_start: 'Get Started',
  onboarding_dialog_aria: 'Welcome tutorial',
  onboarding_slide_aria: 'Slide {current} of {total}',
  onboarding_slide1_title: 'Trade in Person',
  onboarding_slide1_desc: 'SwapWish connects TCG collectors in your area. No shipping, no risk: find someone who has your cards, agree via chat, and meet in person.',
  onboarding_slide2_title: 'Your Binder',
  onboarding_slide2_desc: 'Add cards or sealed products to trade in your Binder. Items involved in an active Match stay locked until it is resolved; you can also create up to 3 decks for free.',
  onboarding_slide3_title: 'Your Wishlist',
  onboarding_slide3_desc: 'Add cards or sealed products you want to your Wishlist. The system suggests both mutual trades and collectors who have what you need but want nothing from your Binder; in that case, you can offer a cash amount.',
  onboarding_slide4_title: 'Match & Meet Up',
  onboarding_slide4_desc: 'When you tap Trade on a compatible profile, it becomes a Match. Go to Matches, chat to agree, and exchange items in person - safe and direct, no middlemen.',
  onboarding_slide5_title: 'Find Nearby Collectors',
  onboarding_slide5_desc: 'Enable location or save an address in Settings to find compatible collectors. Adjust the range from Filters in Discover: up to 25 km on the Free plan, up to 500 km with Pro. Your exact location is never stored.',

  // --- Swipe stamps ---
  stamp_like: 'MATCH',
  stamp_nope: 'SWIPE',
  stamp_in_wishlist: 'In your wishlist',

  // --- Location source ---
  location_source_gps: 'GPS active',
  location_source_address: 'Using profile address',
  settings_address_geo_hint: 'Your address is not public: an approximate position of about 1 km is used. GPS position always takes priority.',

  // --- Catalog: condition selector ---
  catalog_condition_label: 'Condition',
  catalog_language_label: 'Language',
  catalog_grading_company_label: 'Grading',
  catalog_grading_company_none: 'None',
  catalog_grade_label: 'Grade',
  catalog_grade_placeholder: 'Select',
  catalog_price_label: 'Price',
  catalog_notes_label: 'Notes',
  catalog_notes_placeholder: 'Indicate any sub-grades',
  catalog_notes_placeholder_extra: 'Indicate extra info (stamped, sealed, etc.)',
  deck_builder_title: 'Deck Builder',

  matches_delete: 'Delete',
  matches_send_trade: 'Send trade',
  matches_waiting_acceptance: 'Waiting',
  matches_waiting_details_button: 'Waiting — open trade details',
  matches_accept_trade: 'Accept trade',

  // --- Support ---
  profile_contacts: 'Contacts',
  donate_title: 'Donate with PayPal',
  donate_back_label: 'Back to profile',
  donate_eyebrow: 'Thanks for the support',
  donate_heading: 'Support SwapWish',
  donate_description:
    'If SwapWish is helping you find better trades, you can support development with a PayPal donation.',
  donate_account_label: 'PayPal account',
  donate_paypal_button: 'Open PayPal',
  donate_paypal_button_aria: 'Open PayPal in a new window',
  donate_paypal_item_name: 'SwapWish TCG donation',
  donate_paypal_note: 'You will be redirected to PayPal to complete the donation securely.',
  contacts_title: 'Contacts',
  contacts_email_section: 'Get in touch',
  contacts_email_hint: 'Write to us for support, reports or suggestions.',
  contacts_email_copied: 'Email address copied',
  contacts_social_section: 'Social',
  contacts_telegram: 'Telegram community',
  contacts_instagram: 'Instagram',

  // --- Match notifications ---
  matches_trade_sent: 'Proposal sent!',
  matches_trade_accepted: 'Trade accepted!',
  matches_match_deleted: 'Match deleted',
  matches_section_three_way: 'Three-way',
  matches_three_way_empty_title: 'No three-way trades',
  matches_three_way_empty_desc: 'When you propose or receive a three-way trade, it shows up here.',
  matches_three_way_proposal_title: 'Three-way trade proposal',
  matches_three_way_role_proposer: 'Proposed by you',
  matches_three_way_role_participant: 'Awaiting your response',
  matches_three_way_accepted: 'Three-way trade accepted!',
  matches_three_way_declined: 'Proposal declined.',
  matches_three_way_detail_button: 'Details',
  matches_three_way_leg_a_to_b: '{a} gives to {b}',
  matches_three_way_leg_b_to_a: '{b} gives to {a}',
  matches_three_way_leg_c_to_b: '{c} gives to {b}',
  matches_three_way_leg_b_to_c: '{b} gives to {c}',
  matches_three_way_leg_c_to_a: '{c} gives to {a}',
  // Labels for the 3 sections of the three-way trade, from the point of view of
  // whoever is looking at the modal (my_role). Sections: ab = A→B, bc = B→C, ca = C→A.
  matches_three_way_sec_proposer_ab: 'You give to {b}',
  matches_three_way_sec_proposer_bc: '{b} gives to {c}',
  matches_three_way_sec_proposer_ca: 'You receive from {c}',
  matches_three_way_sec_b_ab: 'You receive from {a}',
  matches_three_way_sec_b_bc: 'You give to {c}',
  matches_three_way_sec_b_ca: '{c} gives to {a}',
  matches_three_way_sec_c_ab: '{a} gives to {b}',
  matches_three_way_sec_c_bc: 'You receive from {b}',
  matches_three_way_sec_c_ca: 'You give to {a}',
  matches_three_way_role_a: '{user} (proposer)',
  matches_three_way_role_b: '{user}',
  matches_three_way_role_c: '{user}',
  matches_three_way_you_suffix: '(you)',
  matches_three_way_status_pending: 'Pending',
  matches_three_way_status_accepted: 'Accepted',
  matches_three_way_status_declined: 'Declined',
  matches_three_way_role_participant_waiting: 'Waiting for the other participants to accept',
  matches_three_way_unknown_user: 'Unknown user',
  matches_three_way_leg_min_one: 'Each step must keep at least one item',
  matches_three_way_cash_required: 'Set the cash amount before sending the trade',
  three_way_review_title: 'Rate the participants',
  three_way_review_hint: 'Leave a rating for each of the other participants in this three-way trade.',
  three_way_review_all_done: 'You have already reviewed this trade.',
  history_section_three_way: 'Three-way',
  history_three_way_empty_title: 'No completed three-way trades',
  history_three_way_empty_desc: 'Completed three-way trades will appear here.',
  history_three_way_proposal_title: 'Three-way trade',
  details_unavailable_section: 'Already proposed in another match',
  details_available_section: 'Available items',
  details_total: 'Total',
  details_cash: 'Amount',
  details_cash_pending: 'Cash amount',
  details_cash_extra: 'Extra',
  details_trade_requirement_badge: 'To send the trade, complete the column by entering an amount/extra or selecting at least one card or sealed product.',
  details_peer_item_required_badge: 'The match includes cards or sealed products from {user}: select at least one with a quantity greater than zero. An amount/extra may be added, but cannot replace them.',
  details_column_required: "Select at least one card/sealed product or enter an amount in {user}'s column",
  details_unavailable_committed_badge: 'Unavailable items are already committed in another match.',
  details_conflict_accept_blocked: 'One or more proposed items are already committed in another pending trade: to accept, first complete or delete the other trade.',
  details_traded_section: 'Traded items',
  details_not_traded_section: 'Not tradable items',
  matches_details_validation_loading: 'Validating item availability…',
  matches_trade_block_my_inventory: 'One or more items you are offering are already committed in another pending proposal: you don\'t have enough copies available.',
  matches_trade_block_peer_inventory: 'The other user is already offering one of the requested items in another pending proposal. Try again later.',
  matches_trade_block_initiator_inventory: 'The user who sent you this proposal no longer has enough copies: the item is already committed in another pending proposal.',
  matches_trade_block_wishlist: 'You already have another pending proposal delivering this item: accepting would exceed your wishlist quantity.',
  matches_trade_block_no_valid_cards: 'You cannot send the proposal: there are no valid available quantities among the selectable items.',
  matches_trade_insufficient_my_inventory: 'You don\'t have enough copies available of one or more items you are offering.',
  matches_trade_insufficient_initiator_inventory: 'The user who sent you this proposal no longer has enough copies of one or more items.',
  matches_trade_insufficient_wishlist: 'Your wishlist quantity for one or more items is not enough to accept this trade.',
  matches_no_available_cards: 'There are no available items',
  matches_chat_hint_outgoing_items: [
    'Tap the match to open chat and agree, or agree in person.',
    'After agreeing, use Details to choose cards and quantities and send the proposal.',
    'Waiting reopens the details in read-only mode.',
    'Swipe left from anywhere on the row to delete the match.',
  ],
  matches_chat_hint_incoming: 'Tap the match to open chat and agree, or agree in person. After agreeing, use Details to review and accept the proposal. Swipe left from anywhere on the row to delete the match.',
  matches_chat_button: 'Chat',
  matches_details_button: 'Details',
  matches_row_menu: 'Match actions',

  // --- Pro tier / Multi-TCG / History ---
  profile_pro_status_active: 'Pro subscription active',
  profile_go_pro_badge: 'Go Pro',
  settings_pro_membership_title: 'Pro subscription',
  settings_pro_expiry_value: 'Expires on: {date}',
  settings_pro_expiry_unknown: 'Date unavailable',
  settings_pro_cancel_btn: 'Cancel subscription',
  settings_pro_cancel_scheduled: 'Cancellation already scheduled at period end.',
  settings_pro_cancel_confirm_title: 'Confirm cancellation',
  settings_pro_cancel_confirm_message: 'Your Pro plan will remain active until {date}. Continue?',
  settings_pro_cancel_success_title: 'Cancellation scheduled',
  settings_pro_cancel_success_message: 'Your subscription will be cancelled at period end.',
  settings_pro_cancel_failed_message: 'Unable to cancel the subscription. Please try again.',
  settings_pro_cancel_manual_title: 'External cancellation required',
  settings_pro_cancel_manual_message: 'For subscriptions managed by the stores (Google Play / App Store), cancel directly from that provider account.',
  settings_push_title: 'Push notifications',
  settings_push_desc: 'Enable push notifications to receive matches, trades and reviews instantly.',
  settings_push_activate_btn: 'Enable',
  settings_push_activated: 'Push notifications enabled.',
  settings_push_activate_error: 'Unable to enable push notifications.',
  settings_push_disabled: 'Push notifications disabled.',
  settings_push_permission_denied: 'Notification permission denied by the system. Enable it in your device settings.',
  settings_clear_collection_title: 'Clear',
  settings_clear_scope_all: 'Inventory and Wishlist',
  settings_clear_scope_inventory: 'Inventory',
  settings_clear_scope_wishlist: 'Wishlist',
  settings_clear_btn: 'Clear',
  settings_clear_confirm_title: 'Clear {scope}?',
  settings_clear_confirm_message: 'All cards and sealed products in this section will be permanently deleted. Completed trades in your history will remain available.',
  settings_clear_confirm_cta: 'Clear now',
  settings_clear_success: 'Section cleared successfully.',
  settings_clear_error: 'Unable to clear the section. Please try again later.',
  settings_clear_active_matches: 'You still have open active matches. Close or complete them before clearing this section.',
  settings_delete_account: 'Delete account',
  settings_delete_account_desc: 'Permanently delete your account and associated data.',
  settings_delete_account_confirm_title: 'Delete your account?',
  settings_delete_account_confirm_message: 'This action is irreversible: profile, collection, wishlist, matches, chats and reviews will be permanently deleted. Any active Pro subscription will be automatically cancelled on Google Play (no refund for the period already paid).',
  settings_delete_account_confirm_cta: 'Delete permanently',
  settings_delete_account_error: 'Could not delete the account. Please try again later.',
  settings_delete_account_sub_cancel_failed: 'Could not automatically cancel the Pro subscription. Cancel it from Google Play (Payments & subscriptions → Subscriptions), then retry deleting your account.',
  history_title: 'Trade history',
  history_empty: 'No completed trades yet.',
  history_unavailable_card_label: 'Card no longer available',

  // --- Price info modal ---
  price_info_title: 'Price information',
  price_info_set_price: 'Set price',
  price_info_loading: 'Loading prices...',
  price_info_no_data: 'No price data available.',
  price_info_filter_language: 'Language',
  price_info_filter_type: 'Type',
  price_info_market_prices: 'Market prices',
  price_info_estimate_badge: 'estimate',
  price_info_market_updating: 'Updating market prices…',
  price_info_no_market_for_language: 'No market data for this language.',
  price_info_stats_title: 'Stats and history',
  price_info_stats_loading: 'Loading stats…',
  price_info_history_title: 'Price history',
  price_info_history_no_points: 'Not enough points for the selected period.',
  price_info_no_stats: 'No detailed stats for this card.',
  price_info_graded_title: 'Graded listings',
  price_info_graded_company: 'Company',
  price_info_graded_grade: 'Grade',
  price_info_ebay_title: 'Latest eBay sold',
  price_info_ebay_loading: 'Loading eBay sold items...',
  price_info_ebay_empty: 'No eBay sold items available.',
  price_info_variant_normal: 'Holo/Normal',
  price_info_variant_reverse: 'Reverse',
  price_info_label_min: 'Min',
  price_info_label_avg: 'Avg',
  price_info_label_trend: 'Trend',
  price_info_label_low: 'Low',
  price_info_label_market: 'Market',
  price_info_label_mid: 'Mid',
  price_info_today: 'Today',
  price_info_period_7d: '7d',
  price_info_period_30d: '30d',

  // --- Details modal ---
  details_readonly_info: 'Quantities can only be changed by the user who sent the proposal, and only while sending the trade in the Match section',
  details_proposal_sent_info: 'Trade proposal sent, quantities cannot be changed.',
  details_offer: 'Offer',
  details_obtain: 'Obtain',
  details_request: 'Ask',
  details_select_all: 'Select all',
  details_deselect_all: 'Deselect all',

  // --- Landing page ---
  landing_header_features: 'Features',
  landing_header_how_it_works: 'How it works',
  landing_header_download: 'Download',
  landing_header_login: 'Log in',
  landing_hero_badge: 'Available on Android',
  landing_hero_title: 'SwapWish TCG',
  landing_hero_title_accent: 'in-person trades for collectors',
  landing_hero_desc: 'Manage your collection, decks and wishlist, scan cards with the camera, find compatible candidates on the map — including three-way trades or cash-settled legs — then agree in chat to trade in person.',
  landing_hero_download_btn: 'Download for Android',
  landing_hero_ios_btn: 'App Store - Coming soon',
  landing_hero_slide_inventory: 'Collection',
  landing_hero_slide_wishlist: 'Focused wishlist',
  landing_hero_slide_map: 'Trade map',
  landing_hero_slide_filters: 'Active filters',
  landing_hero_slide_candidates: '3 candidates',
  landing_hero_slide_chat: 'Matches and chat',
  landing_hero_slide_trade_ready: 'Proposal ready',
  landing_hero_slide_meet: 'In-person meetup',
  landing_hero_slide_inventory_meta: 'Cards, sealed, variants',
  landing_hero_slide_wishlist_meta: 'Condition, language, quantity',
  landing_hero_slide_map_tab: 'Map',
  landing_hero_slide_your_cards: '2 items',
  landing_hero_slide_their_card: '1 items',
  landing_hero_slide_peer_message: 'Perfect, shall we meet Saturday?',
  landing_hero_slide_my_message: 'Great! See you Saturday 👍',
  landing_preview_title: 'A look inside the app',
  landing_preview_subtitle: "A preview of SwapWish's main views, featuring Mario's sample Pokémon collection.",
  landing_preview_prev: 'Previous slide',
  landing_preview_next: 'Next slide',
  landing_features_label: 'Features',
  landing_features_title: 'From binder',
  landing_features_title_accent: 'to the trade map',
  landing_features_desc: 'SwapWish TCG organizes your cards/sealed products, shows compatible collectors nearby, and helps you close every trade clearly.',
  landing_feature_swipe_title: 'Collection, decks and scanner',
  landing_feature_swipe_desc: 'Add cards and sealed products by searching the catalog or scanning them with the camera (including bulk import from CardTrader, Cardmarket or TCGplayer), organize your decks, and check up-to-date market prices.',
  landing_feature_nearby_title: 'Map, leaderboard and candidates',
  landing_feature_nearby_desc: 'View compatible users — including those who have a card you want, settled with cash — apply filters and radius, and browse the Trade Leaderboard with history, collection and reviews of nearby collectors.',
  landing_feature_realtime_title: 'Matches, chat and alerts',
  landing_feature_realtime_desc: 'Start a proposal, follow match status, get notified when a new compatible collector enters your range, and agree in chat on the place and details of the trade.',
  landing_feature_multi_title: 'Pro: multi-TCG, three-way trades and extended range',
  landing_feature_multi_desc: 'Search across multiple games and up to 500 km, unlock unlimited slots, and discover three-way trades — even when one leg is settled in cash instead of cards.',
  landing_how_label: 'How it works',
  landing_how_title: 'Three steps',
  landing_how_title_accent: 'to the perfect trade',
  landing_how_add_title: 'Load inventory and wishlist',
  landing_how_add_desc: 'Search the catalog or scan cards with the camera, set quantity, condition and language, and check market prices before proposing.',
  landing_how_find_title: 'Filter the map and open candidates',
  landing_how_find_desc: 'Choose radius, games and products: SwapWish shows compatible profiles and available proposals.',
  landing_how_close_title: 'Propose, chat and meet',
  landing_how_close_desc: 'Confirm the trade, agree in chat, and complete the handoff in person.',
  landing_download_label: 'Download',
  landing_download_title: 'Start trading',
  landing_download_title_accent: 'today',
  landing_download_desc: 'Download the app for free, create your binder, and start finding trades near you.',
  landing_download_android_req: 'Android 8.0+',
  landing_download_android_status: 'Available',
  landing_download_android_desc: 'Install the APK directly, no Play Store needed. Automatic in-app updates.',
  landing_download_android_btn: 'Download app',
  landing_download_free: 'Free',
  landing_download_no_ads: 'No ads',
  landing_download_updates: 'Free updates',
  landing_download_ios_req: 'iOS 16+',
  landing_download_ios_status: 'Coming soon',
  landing_download_ios_desc: 'The iOS version is in active development. Join the waitlist to be the first to try it.',
  landing_download_ios_hint: 'Want to be notified?',
  landing_download_ios_contact: 'Contact us',
  landing_modal_aria: 'Download SwapWish TCG',
  landing_modal_close: 'Close',
  landing_modal_title: 'Android Download',
  landing_modal_subtitle: 'APK file · In-app updates',
  landing_modal_download_btn: 'Download APK',
  landing_modal_downloading: 'Downloading...',
  landing_modal_downloaded: 'Download complete',
  landing_modal_download_error: 'Download failed. Verify the APK file is correctly published and try again.',
  landing_modal_how_to_install: 'How to install',
  landing_modal_step1_title: 'Open the downloaded file',
  landing_modal_step1_desc: 'Find the APK file in your device\'s Downloads folder.',
  landing_modal_step2_title: 'Allow unknown sources',
  landing_modal_step2_desc: 'In settings, enable <em>"Install apps from unknown sources"</em>.',
  landing_modal_step3_title: 'Install the app',
  landing_modal_step3_desc: 'Follow the on-screen installation instructions.',
  landing_modal_step4_title: 'Open it and sign up',
  landing_modal_step4_desc: 'Create your account and start finding trades near you.',
  landing_modal_safety: 'Safe file, verified by the SwapWish team.',
  landing_footer_tagline: 'The TCG card trading platform for collectors.',
  landing_footer_nav_aria: 'Footer navigation',
  landing_footer_app_section: 'App',
  landing_footer_features: 'Features',
  landing_footer_how_it_works: 'How it works',
  landing_footer_download_android: 'Download for Android',
  landing_footer_support_section: 'Support',
  landing_footer_contact: 'Contact us',
  landing_footer_webapp: 'Access Web App',
  landing_footer_legal_section: 'Legal',
  landing_footer_privacy: 'Privacy Policy',
  landing_footer_terms: 'Terms of Service',
  landing_footer_delete_account: 'Delete account',
  landing_footer_child_safety: 'Child safety',
  landing_footer_copyright: '© {year} SwapWish TCG. All rights reserved.',
  landing_footer_made: 'Made with ♥ for collectors',

  // --- Product type tabs (Inventory / Wishlist / Catalog) ---
  tab_type_cards: 'Cards',
  tab_type_sealed: 'Sealed',
  sealed_no_year: 'Unknown year',
  sealed_empty_desc: 'Add sealed products to see them here.',
  cards_empty_desc: 'Add cards to see them here.',

  // --- Language tab filter (Collection / Wishlist / Catalog) ---
  lang_tab_global: 'Western',
  lang_tab_asia: 'Eastern',
  lang_tab_english: 'English',

  // --- Expansion grid + expansion view ---
  expansion_search_placeholder: 'Search expansion',
  viewing_language_label: 'Viewing language:',
  grid_cols_toggle_label: 'Grid columns',
  grid_cols_2: 'Show 2 per row',
  grid_cols_4: 'Show 4 per row',
  card_scan_button_label: 'Scan a card',
  card_scan_title: 'Card scan',
  card_scan_free_limit: 'Free: {limit} scans/day · Left: {remaining}',
  card_scan_pro_unlimited: 'PRO: unlimited scans',
  card_scan_starting: 'Starting camera…',
  card_scan_scanning: 'Frame the card in the guide: name and number clearly visible',
  card_scan_results_title: 'Is it one of these?',
  card_scan_limit_reached: 'You used all your free scans for today. Go PRO for unlimited scans.',
  card_scan_camera_error: 'Camera unavailable or permission denied.',
  card_scan_permission_denied: 'Camera permission is required to scan cards. Grant it to continue.',
  card_scan_permission_blocked: 'Camera permission denied. Enable it in the app settings to scan cards.',
  card_scan_open_settings: 'Open settings',
  card_scan_camera_timeout: 'Camera failed to start (timed out). Check permissions and try again.',
  card_scan_grant_permission: 'Grant permission',
  card_scan_error: 'Scan failed. Please try again.',
  card_scan_cards_only: 'Works with single cards only, not sealed products.',
  card_scan_game_hint: 'Scanning {game}',
  card_scan_resume: 'Resume scanning',
  card_scan_not_found: 'Card not found',
  card_scan_retry: 'Try again',
  card_scan_alternatives: 'Other matches',
  card_scan_choose_type: 'What do you want to scan?',
  card_scan_choose_type_help: 'Choose card recognition or a graded-card certificate.',
  card_scan_type_raw: 'Card',
  card_scan_type_raw_help: 'Recognise an ungraded card from its image and text.',
  card_scan_type_graded: 'Graded card',
  card_scan_type_graded_help: 'Read the QR code or enter the slab certificate.',
  graded_scan_title: 'Graded card',
  graded_scan_choose_provider: 'Choose the grading company',
  graded_scan_provider_help: 'The provider detected from the QR code will be compared with your selection.',
  graded_scan_automatic: 'Automatic',
  graded_scan_assisted: 'Assisted',
  graded_scan_manual_badge: 'Manual',
  graded_scan_scan_qr: 'Scan QR code',
  graded_scan_enter_cert: 'Enter certificate',
  graded_scan_cert_number: 'Certificate number',
  graded_scan_continue: 'Continue',
  graded_scan_scanning_qr: 'Frame the slab QR code',
  graded_scan_camera_unavailable: 'Camera unavailable. You can enter the certificate manually.',
  graded_scan_qr_decoder_unavailable: 'The native QR decoder is unavailable on this device. Use the certificate number.',
  graded_scan_empty: 'Enter a certificate.',
  graded_scan_unsupported_qr: 'Unrecognised QR code: only official HTTPS URLs from supported graders are accepted.',
  graded_scan_invalid_cert_number: 'Invalid certificate number.',
  graded_scan_provider_conflict_title: 'The grader does not match',
  graded_scan_provider_conflict: 'You selected {selected}, but the QR code appears to belong to {detected}. Confirm which one to use.',
  graded_scan_use_detected: 'Use {provider}',
  graded_scan_keep_selected: 'Keep {provider}',
  graded_scan_lookup: 'Verifying certificate…',
  graded_scan_matching: 'Searching the catalogue…',
  graded_scan_ambiguous_title: 'Choose the correct card',
  graded_scan_ambiguous_help: 'The certificate data matches multiple cards. Check set, number and year.',
  graded_scan_match_score: '{score}% match',
  graded_scan_search_catalog: 'Search catalogue',
  graded_scan_assisted_title: 'Assisted verification',
  graded_scan_assisted_help: 'Open the official site, verify the certificate, then complete the grade and card without leaving this flow.',
  graded_scan_verify_official: 'Verify on official website',
  graded_scan_manual_verified_confirm: 'I confirm that I verified this certificate on the grader’s official website.',
  graded_scan_manual_unverified_confirm: 'I understand that this certificate cannot be verified automatically and confirm the entered details.',
  graded_scan_grade: 'Grade',
  graded_scan_already_imported: 'Certificate already added',
  graded_scan_duplicate_help: 'The existing copy was kept; its quantity was not increased.',
  graded_scan_another: 'Scan another card',
  graded_scan_cert_verified: 'Certificate found',
  graded_scan_assisted_result: 'Confirm the details',
  graded_scan_authenticity_disclaimer: 'Verifying the record does not prove that the physical slab is authentic.',
  graded_scan_subject: 'Subject',
  graded_scan_provider_status: 'Provider status',
  graded_scan_year: 'Year',
  graded_scan_variety: 'Variety',
  graded_scan_language_confirm: 'Card language',
  graded_scan_choose_language: 'Confirm the language',
  graded_scan_variant_confirm: 'Variant',
  graded_scan_choose_variant: 'Confirm the variant',
  graded_scan_no_variant: 'No variant',
  graded_scan_unsupported_grade: 'The provider grade cannot be represented and will not be rounded.',
  graded_scan_add_inventory: 'Add to inventory',
  graded_scan_choose_another: 'Choose another card',
  graded_scan_added: 'Card added',
  graded_scan_added_help: 'One copy was added with an undoable receipt.',
  graded_scan_undo_done: 'Addition undone.',
  graded_scan_error_title: 'Verification failed',
  graded_scan_manual_fallback: 'Use manual flow',
  graded_scan_game_required: 'Select a game in your inventory first.',
  graded_scan_error_unauthorized: 'Invalid session. Sign in again.',
  graded_scan_error_invalid_request: 'Incomplete or invalid data.',
  graded_scan_error_invalid_provider: 'Unsupported grader.',
  graded_scan_error_invalid_cert_number: 'Invalid certificate number.',
  graded_scan_error_provider_conflict: 'The selected grader does not match the QR code.',
  graded_scan_error_provider_not_configured: 'Automatic verification for this provider is not configured yet.',
  graded_scan_error_provider_unavailable: 'The official service is unavailable. Try again later.',
  graded_scan_error_provider_rate_limited: 'Provider limit reached. Try again later.',
  graded_scan_error_provider_record_inactive: 'The certificate record is inactive, revoked or invalid.',
  graded_scan_error_cert_not_found: 'Certificate not found in the official database.',
  graded_scan_error_unsupported_grade: 'Unsupported grade.',
  graded_scan_error_catalog_match_ambiguous: 'Ambiguous catalogue match.',
  graded_scan_error_catalog_match_not_found: 'Card not found in the selected game.',
  graded_scan_error_language_required: 'Confirm a valid language.',
  graded_scan_error_variant_required: 'Confirm a valid variant.',
  graded_scan_error_duplicate_cert: 'Certificate already present.',
  graded_scan_error_slot_limit_reached: 'Slot limit reached.',
  graded_scan_error_protected_quantity: 'This copy is committed to an active match and cannot be removed.',
  graded_scan_error_import_not_found: 'Import receipt not found.',
  graded_scan_error_lookup_expired: 'The verification expired. Run it again.',
  graded_scan_lookup_again: 'Verify again',
  graded_scan_error_scan_limit_reached: 'You have no scans left today.',
  graded_scan_error_internal_error: 'Unexpected error. Try again.',
  expansion_card_count: '{count} cards',
  expansion_product_count: '{count} products',
  set_card_badge_cards: '{count} cards',
  set_card_badge_sealed: '{count} sealed',
  expansion_back: 'Expansions',
  sets_empty_title: 'No expansions',
  sets_empty_desc: 'No expansions available for the selected filters.',
  expansion_kind_main: 'Main',
  expansion_kind_promo: 'Promo',
  expansion_kind_extra: 'Promo & Extra',
  expansion_kind_deck: 'Decks',
  expansion_count_label: 'Expansions: {count}',
  inventory_photos_title: 'Attached photos',
  inventory_photo_view: 'View attached photos',
  inventory_photo_alt: 'Attached item photo',
  inventory_photo_add: 'Add photo',
  inventory_photo_delete: 'Delete photo',
  inventory_photo_expand: 'Expand photo',
  inventory_photo_collapse: 'Return to gallery',
  inventory_photo_edit_mode_hint: 'To add or remove photos, enter card edit mode.',
  inventory_photo_empty: 'No attached photos.',
  media_load_error: 'Could not load the attached photos.',
  media_upload_error: 'The file could not be uploaded.',
  media_delete_error: 'The photo could not be deleted.',
  media_blocked_error: 'Upload blocked: the content may be inappropriate, explicit, or illegal.',
  moderation_unavailable_error: 'The safety check is temporarily unavailable. Upload was blocked; try again later.',
  media_invalid_error: 'The selected image or video cannot be checked safely.',

  // ── Verified features: profile verification, tournaments, banners ──────────
  profile_request_verification: 'Request verification',
  profile_verified_features: 'Verified features',
  profile_manage_banners: 'Manage banners',
  profile_manage_verifications: 'Manage verifications',

  verify_title: 'Request verification',
  verify_subtitle: 'Become a verified profile (shop, association or other) to create tournaments that appear on the map and display a banner on the map to promote your business to users in your city.',
  verify_activity_type: 'Activity type',
  verify_activity_shop: 'Shop',
  verify_activity_association: 'Association',
  verify_activity_organizer: 'Organizer',
  verify_activity_other: 'Other',
  verify_activity_name: 'Activity name',
  verify_vat: 'VAT / Tax number',
  verified_badge_label: 'Verified profile',
  verify_cf: 'Tax code (Codice Fiscale)',
  verify_piva: 'VAT number',
  verify_need_cf: 'Enter the tax code',
  verify_invalid_cf: 'Invalid tax code',
  verify_need_piva: 'Enter the VAT number',
  verify_invalid_piva: 'Invalid VAT number',
  // Users outside Italy: single generic field instead of CF+VAT.
  verify_business_id: 'Business identification number',
  verify_need_business_id: 'Enter the business identification number',
  verify_need_first_last: 'Enter first and last name',
  verify_proofs_hint: 'Attach the front and back of your ID card or passport.',
  verify_contact_note: 'Notes (optional)',
  verify_add_proof: 'Add document',
  verify_submit: 'Send request',
  verify_pending_title: 'Request pending',
  verify_pending_desc: 'Your verification request is under review.',
  verify_submitted: 'Request sent',
  verify_error: 'Could not send the request',
  verify_need_name: 'Enter the activity name',
  verify_need_proof: 'Attach the front and back of your document (at least 2 files)',

  vf_title: 'Verified features',
  vf_configure_banner: 'Configure banner',
  vf_configure_banner_desc: 'Create a branded banner for your city.',
  vf_manage_tournaments: 'Manage tournaments',
  vf_manage_tournaments_desc: 'Create and manage your tournament and participants.',

  // ── Tournaments ────────────────────────────────────────────────────────────
  tourn_button: 'Tournaments',
  tourn_list_title: 'Tournaments',
  tourn_list_eyebrow: 'Near you',
  tourn_empty_title: 'No tournaments nearby',
  tourn_empty_desc: 'There are no tournaments within your search radius right now.',
  tourn_participants_count: '{count} participants',
  tourn_participants_list: 'Participant list',
  tourn_entry_fee: 'Entry fee',
  tourn_free_entry: 'Free',
  tourn_date: 'Date',
  tourn_time: 'Time',
  tourn_location: 'Location',
  tourn_organizer: 'Organizer',
  tourn_contact_phone: 'Phone',
  tourn_contact_email: 'Email',
  tourn_description: 'Description',
  tourn_request_participation: 'Request to join',
  tourn_participation_pending: 'Request sent',
  tourn_participation_accepted: 'Participation confirmed',
  tourn_participation_rejected: 'Request declined',
  tourn_view_profile: 'View profile',
  tourn_request_title: 'Request to join',
  tourn_request_first_name: 'First name',
  tourn_request_last_name: 'Last name',
  tourn_request_phone: 'Phone number',
  tourn_request_send: 'Send request',
  tourn_request_error: 'Could not send the request',
  tourn_request_need_fields: 'Fill in first name, last name and phone',
  // ── Tournaments: invite-only / invite link ──
  tourn_invite_only: 'Invite only',
  tourn_invite_only_hint: 'The tournament will not appear on the map: share the invite link to let people join.',
  tourn_invite_badge: 'Invite only',
  tourn_invite_link_label: 'Invite link',
  tourn_invite_copy: 'Copy',
  tourn_invite_copied: 'Copied!',
  tourn_invite_share: 'Share',
  tourn_invite_share_text: 'Join the tournament "{name}" on SwapWish!',
  tourn_invite_join_title: 'Join tournament',
  tourn_invite_join_send: 'Join',
  tourn_participants_title: 'Participants',
  tourn_no_participants: 'No participants',
  tourn_participant_accept: 'Accept',
  tourn_participant_reject: 'Decline',
  tourn_pending_badge: 'Pending',
  tourn_accepted_badge: 'Accepted',
  tourn_rejected_badge: 'Declined',

  tourn_create: 'Create tournament',
  tourn_create_title: 'Create tournament',
  tourn_name: 'Tournament name',
  tourn_game: 'Game type',
  tourn_game_placeholder: 'Select game',
  tourn_max_short: 'Max part.',
  tourn_max_participants: 'Max participants',
  tourn_image: 'Image',
  tourn_add_image: 'Add image',
  tourn_location_hint: 'Enter the tournament location',
  tourn_create_submit: 'Create tournament',
  tourn_create_short: 'Create tournament',
  tourn_created: 'Tournament created',
  tourn_create_error: 'Could not create the tournament',
  tourn_create_need_fields: 'Fill in name, date and location',
  tourn_cancel: 'Cancel tournament',
  tourn_cancel_confirm: 'Do you want to cancel the tournament?',
  tourn_cancelled: 'Tournament cancelled',
  tourn_manage_title: 'Manage tournaments',
  tourn_no_active: 'You have no active tournaments',
  tourn_one_active_hint: 'You can have only one active tournament at a time.',
  tourn_max_active_hint: 'You can have up to 5 active tournaments at the same time.',
  tourn_active_counter: '{count}/{max} active tournaments',
  tourn_requests: 'Participation requests',
  tourn_history_title: 'Tournament history',
  tourn_history_empty: 'No completed tournaments',
  tourn_history_empty_hint: 'Tournaments closed with "Complete" will appear here with their winner.',
  tourn_delete: 'Delete',
  tourn_delete_confirm_title: 'Delete tournament',
  tourn_delete_confirm_msg: 'The tournament "{name}" will be permanently removed and will NOT appear in the history. Continue?',
  tourn_delete_error: 'Could not delete the tournament',
  tourn_complete: 'Complete',
  tourn_complete_short: 'Complete',
  tourn_complete_title: 'Complete tournament',
  tourn_complete_pick_winner: 'Select the tournament winner among the accepted participants: the tournament will be moved to the history.',
  tourn_complete_need_winner: 'Select a winner',
  tourn_complete_no_participants: 'No accepted participants: accept at least one participant to complete the tournament.',
  tourn_complete_error: 'Could not complete the tournament',
  tourn_winner: 'Winner',
  // ── Tournaments: edit/duplicate/reminder/wins ──
  tourn_edit: 'Edit',
  tourn_edit_title: 'Edit tournament',
  tourn_edit_hint: 'You can change name, description, time, image and contacts. Date, venue, entry fee and max participants are locked: participants joined under those conditions.',
  tourn_duplicate: 'Duplicate',
  notif_tournament_reminder: 'Reminder: a tournament you joined takes place tomorrow',
  leaderboard_tournament_wins: '{count} tournaments won',
  // ── Banners: queue, metrics, non-Android payment ──
  banner_queue_position: 'You are #{position} in the queue for this city.',
  banner_stat_impressions: 'Views',
  banner_stat_clicks: 'Clicks',
  banner_pay_open_android: 'Payment is completed from the Android app: open SwapWish on your Android device and go back to "Configure banner" to pay. iOS support coming soon.',
  // ── Guided tour: tournaments and verified features ──
  tour_profile_verified_title: 'Are you a shop or an association?',
  tour_profile_verified_text: 'From your Profile you can request verification: once verified you can create tournaments on the map and book branded banners for your city.',
  // ── What's new (one-shot per version) ──
  whats_new_eyebrow: 'What’s new',
  whats_new_title: 'What’s new on SwapWish',
  whats_new_tournaments_title: 'Tournaments on the map',
  whats_new_tournaments_text: 'Verified shops and associations run tournaments near you: check them on the map and request to join.',
  whats_new_banner_title: 'Your city’s banner',
  whats_new_banner_text: 'Verified profiles can book a branded banner shown on the map to users in their city.',
  whats_new_chat_title: 'Improved chat',
  whats_new_chat_text: 'Read receipts, "typing…", retry for failed messages and trade proposals straight from the chat.',
  whats_new_cta: 'Let’s go',
  // ── My tournaments (participant) ──
  profile_my_tournaments: 'My tournaments',
  mytourn_title: 'My tournaments',
  mytourn_history_title: 'Participation history',
  mytourn_empty: 'No active registrations',
  mytourn_empty_hint: 'Your participation requests for tournaments on the map will appear here with their status.',
  mytourn_history_empty: 'No completed tournaments',
  mytourn_history_empty_hint: 'Completed tournaments you took part in will appear here, along with your wins.',
  mytourn_won_badge: 'Winner',
  // ── My tournaments: join via invite link ──
  mytourn_invite_prompt: 'Have an invite link to a tournament?',
  mytourn_invite_placeholder: 'Paste the invite link here',
  mytourn_invite_search: 'Search',
  mytourn_invite_invalid: 'Invalid invite link or tournament no longer available.',
  mytourn_invite_is_creator: 'This is your own tournament: manage it from Manage Tournaments.',
  mytourn_invite_already: 'You are already registered for this tournament.',
  mytourn_invite_full: 'The tournament has reached the maximum number of participants.',
  // ── Public profile showcase ──
  profile_showcase: 'Profile showcase',
  profile_showcase_products: 'Showcase',
  showcase_title: 'Profile showcase',
  showcase_desc: 'Choose up to 5 cards/products from your inventory and 5 from your wishlist: they’ll be highlighted at the top of your shared public profile.',
  showcase_offer_section: 'Featured inventory',
  showcase_seek_section: 'Featured wishlist',
  showcase_offer_empty: 'No tradeable items in your inventory.',
  showcase_seek_empty: 'Your wishlist is empty.',
  showcase_saved: 'Showcase updated.',
  showcase_add: 'Add',
  showcase_pick_offer_title: 'Add from Inventory',
  showcase_pick_seek_title: 'Add from Wishlist',
  showcase_none_selected: 'No cards are currently featured. Look for one below and select it to add it to the showcase.',
  showcase_added_section: 'Added to showcase',
  showcase_search_placeholder: 'Search a card or sealed product',
  showcase_no_results: 'No results',
  showcase_remove: 'Remove',
  showcase_done: 'Done',
  shared_showcase_title: 'Highlights',
  shared_showcase_offer: 'Offering',
  shared_showcase_seek: 'Seeking',

  tourn_completed_badge: 'Completed',

  // ── CAP banners ────────────────────────────────────────────────────────────
  banner_config_title: 'Configure banner',
  banner_price_badge: 'Only 4.99',
  banner_config_desc: 'The banner will be visible for 7 days only to users in your same city, at the bottom of the map. It becomes visible from the moment the payment is completed.',
  banner_city_label: 'City',
  banner_no_city: 'Set an address with a city to create a banner.',
  banner_text_label: 'Branded text',
  banner_url_label: 'External URL',
  banner_book: 'Book banner',
  banner_pending_approval: 'Awaiting confirmation',
  banner_pay: 'Pay banner',
  banner_pay_price: 'Pay banner (€4.99)',
  banner_approved_notice: 'Banner approved: complete the payment to publish it.',
  banner_slot_occupied: 'Another banner is already active for your city.',
  banner_slot_countdown: 'You will be able to complete the purchase in {time}.',
  banner_active_notice: 'Banner active',
  banner_active_until: 'Active until {date}',
  banner_rejected_notice: 'Banner not approved',
  banner_created: 'Banner booked',
  banner_create_error: 'Could not book the banner',
  banner_monthly_limit: 'You already booked a banner this month.',
  banner_monthly_limit_countdown: 'You can book another one in {time}.',
  banner_pay_error: 'Payment failed',
  banner_pay_mobile_only: 'Payment is available only from the Android app.',
  banner_paid_ok: 'Payment completed',

  admin_banners_title: 'Manage banners',
  admin_banner_sent_at: 'Booked on',
  admin_banners_pending: 'Awaiting approval',
  admin_banners_active: 'Active',
  admin_approve: 'Approve',
  admin_reject: 'Reject',
  admin_no_banners: 'No banners',
  admin_verifications_title: 'Manage verifications',
  admin_no_verifications: 'No requests',
  admin_view_proofs: 'View documents',
  admin_decided_ok: 'Done',

  notif_tournament_created: 'New tournament near you',
  notif_tournament_join_request: 'New request to join your tournament',
  notif_tournament_join_accepted: 'Your tournament participation was accepted',
  notif_tournament_join_rejected: 'Your tournament participation was declined',
  notif_tournament_deleted: 'A tournament you joined was cancelled',
  notif_tournament_completed: 'A tournament you joined has ended',
  notif_tournament_won: 'You won the tournament! 🏆',
  notif_verification_approved: 'Profile verified: you can now create tournaments and banners',
  notif_verification_rejected: 'Verification request not approved',
  notif_banner_approved: 'Banner approved: complete the payment',
  notif_banner_rejected: 'Banner not approved',
  notif_admin_verification_request: 'New verification request received',
  notif_admin_banner_request: 'New banner request received',
  admin_history_title: 'Requests history',
  admin_tab_pending: 'Pending',
  admin_tab_history: 'History',

  // Guide + landing: tournaments and events
  help_section_tournaments_desc: 'Verified shops and associations can create tournaments and events, shown on the map and in the Tournaments list.',
  help_section_tournaments_b1: 'Request verification from your profile to become an organizer.',
  help_section_tournaments_b2: 'Create a tournament with date, place, entry fee and participant limit.',
  help_section_tournaments_b3: 'Nearby users get a notification and can request to join.',
  help_section_tournaments_b4: 'Accept or decline requests and manage the participant list.',
  help_tournaments_title: 'Tournaments and events',
  landing_feature_tournaments_title: 'Tournaments and events',
  landing_feature_tournaments_desc: 'Verified shops and associations run geolocated tournaments and events: find them on the map and join.',

  // ── Collezione: valore, CSV, selezione multipla ──
  bulk_select_toggle: 'Multi-select',
  bulk_select_item: 'Select product',
  bulk_selected_count: '{count} selected',
  bulk_delete: 'Delete',
  bulk_move_to_wishlist: 'Move to Wishlist',
  bulk_move_to_inventory: 'Move to Inventory',
  bulk_delete_confirm_title: 'Delete the selected products?',
  bulk_delete_confirm_message: '{count} products will be removed from your collection.',
  bulk_deleted_flash: 'Deleted {count} products',
  bulk_moved_flash: 'Moved {count} products',
  bulk_locked_item: 'Product committed to an active match: not selectable',
} as const;


